import React, { useEffect, useState } from "react";
import { useFormik, FormikProvider, FieldArray } from "formik"; // Import FormikProvider and FieldArray
import * as yup from "yup";
import {
  Container,
  TextField,
  Button,
  Typography,
  Avatar,
  Box,
  Stepper,
  Step,
  StepLabel,
  InputAdornment,
  IconButton,
  MenuItem,
  Snackbar,
  Alert,
  Divider,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  useTheme,
  useMediaQuery,
  Card,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  CircularProgress,
  Checkbox, // Added for visual separation
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SaveIcon from "@mui/icons-material/Save";
import styles from "./ScholarshipApplicationView.module.scss";
import CustomStepIcon from "../../../components/CommonComponent/CustomStepIcon/CustomStepIcon";
import CustomConnector from "../../../components/CommonComponent/CustomStepIcon/CustomConnector";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AuditLog from "../../../components/AuditLog/AuditLog";
import { auditLogs } from "../../../data/auditLogData";
import { RegionArray } from "../../../data/region";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  applicantData,
  Durations,
  Frequencies,
  KnowApplicationData,
  occupationOptions,
  qualificationOptions,
  Semesters,
  standardOptions,
  statusOptions,
  streamOptions,
} from "../../../data/alldata";
import {
  CustomDataTable,
  TableColumn,
} from "../../../components/CommnTable/CustomDataTable";
import { Download, InfoOutlined } from "@mui/icons-material";
import { Button as PrimeButton } from "primereact/button";
import {
  achievementItemSchema,
  bankDetailsSchema,
  completedEducationItemSchema,
  familyDetailsSchema,
  overallValidationSchema,
  personalInfoSchema,
  presentEducationSchema,
  scholarshipPurposeSchema,
  uploadedDocumentItemSchema,
} from "../../../forms/scholarshipValidation";
import { InitialValues, InitialValuesView } from "../../../types/formTypes";
import {
  configBlobToken,
  configNotCustomToken,
  configWithToken,
  DeleteUrl,
  GetUrl,
  PatchUrl,
  PostUrl,
} from "../../../api/endpointConfig";
// import { usePost } from "../../services/hooks/Method";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { useGet } from "../../../services/hooks/useGet";
import { useNavigate, useParams } from "react-router-dom";
import placeholderImg from "../../../assets/images/nofile.jpg";
import pdfplaceholderImg from "../../../assets/images/pdfview.jpg";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {
  ApplicantForm,
  DorpdownInterFace,
  FilesInterface,
} from "../../../types/types";
import isEqual from "lodash/isEqual";
import set from "lodash/set";
import { useLoader } from "../../../Loader/LoaderContext";
import StatusUpdateModal from "../../Applications/StatusUpdateModal/StatusUpdateModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { API_URL, API_VERSION, BLOB_API } from "../../../config/config";
import axios from "axios";
import { getSecureBlobUrl } from "../../../utils/blobUploader";
import { ToastService } from "../../../utils/toastService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { PdfPreview } from "../../../utils/PdfPreview";
import { has } from "lodash";
const steps = [
  "Personal Info",
  "Completed Education",
  "Present Education",
  "Achievements",
  "Family Details",
  "Scholarship Purpose",
  "Bank Details",
  "Documents",
];
const getStatusChipColor = (status: string) => {
  switch (status) {
    case "approved":
      return "success";
    case "pending":
      return "warning";
    case "rejected":
      return "error";
    case "document_submitted":
      return "info";
    case "pending_additional_documents":
      return "secondary";
    case "scheduled_interview":
      return "primary";
    case "draft":
      return "default";
    default:
      return "default";
  }
};
const sectionStepMap: Record<string, number> = {
  personalInfo: 0,
  completedEducation: 1,
  presentEducation: 2,
  achievementsInfo: 3,
  familyDetails: 4,
  scholarshipPurpose: 5,
  bankDetails: 6,
  uploadedDocuments: 7,
};
type selectRowInerfaec = {
  id: number;
  doc_name: string;
  doc_url: string;
};
const ScholarshipApplicationView: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);

  const [applicationID, setApplicationID] = useState<number | null>(null);

  const [mainData, setMainData] = useState<ApplicantForm[]>([]);
  const [initialValues, setInitialValues] = useState(null);
  const [districtOptions, setDistrictOptions] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<selectRowInerfaec | null>(
    null
  );

  const [statusArr, setStatusArr] = useState<any[]>([]);
  const [dropDownData, setDropDownData] = useState<DorpdownInterFace[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [fileType, setFileType] = useState<string>("");
  const [viewDocModalOpen, setViewDocModalOpen] = useState<boolean>(false);
  const [uploading, setUploading] = useState<boolean>(false);
  const [uploadingIndex, setUploadingIndex] = useState<number | null>(null);
  const [appStatus, setAppStatus] = useState<boolean>(false);
  const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx"];
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const applicationManageArr = useSelector(
    (state: RootState) => state.app.applicationManageData
  );
  const formRef = React.useRef<HTMLDivElement>(null);
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const MAX_FILE_SIZE_MB = 5;
  useEffect(() => {
    if (id) {
      setApplicationID(JSON.parse(id ?? '""'));
    }
  }, []);
  useEffect(() => {
    if (applicationManageArr) {
      if (applicationManageArr[0].status === "approved") {
        setAppStatus(true);
      }
    }
  }, [applicationManageArr]);

  const previewTemplate = (rowData: any) => {
    return (
      <Box onClick={() => setSelectedRow(rowData)}>
        {rowData?.doc_url?.includes(".pdf") ? (
          <>
            <img
              src={pdfplaceholderImg}
              alt="Document Preview"
              style={{
                width: "6rem",
                height: "auto",
                borderRadius: "4px",
                objectFit: "cover",
                boxShadow: "0 0 6px rgba(0,0,0,0.1)",
              }}
            />
          </>
        ) : (
          <>
            <img
              src={rowData.doc_url}
              alt="Document Preview"
              style={{
                width: "6rem",
                height: "auto",
                borderRadius: "4px",
                objectFit: "cover",
                boxShadow: "0 0 6px rgba(0,0,0,0.1)",
              }}
            />
          </>
        )}
      </Box>
    );
  };
  const actionTemplate = (rowData: any) => (
    <Box display="flex" alignItems="center" gap={1}>
      <PrimeButton
        label="Download"
        icon="pi pi-download"
        className="p-button-success p-button-sm commonBtn"
        onClick={async () => {
          try {
            if (!rowData?.doc_name) {
              console.error("Invalid document name");
              return;
            }
            await forceBlobDownload(rowData.doc_url, rowData.doc_name);
          } catch (error) {
            console.error("Download failed:", error);
          }
        }}
        type="button"
      />

      <PrimeButton
        label="Delete"
        icon="pi pi-trash"
        className="p-button-danger p-button-sm"
        onClick={() => {
          handleDeleteDocument(rowData);
        }}
        type="button"
      />
    </Box>
  );
  const forceBlobDownload = async (fileUrl: any, fileName: string) => {
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob",
      });
      const mimeType = response.data.type;
      const blob = new Blob([response.data], { type: mimeType });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  const handleDeleteDocument = async (rowData: any) => {
    console.log("rowData to delete:", rowData);
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this document from the application?"
    );
    if (!confirmDelete) return;

    try {
      if (
        rowData.doc_type === "additional_document" ||
        rowData.doc_type === "achievements"
      ) {
        const getCleanDocUrl = (docUrl: string): string => {
          const baseBlobUrl = `${BLOB_API}/documents/`;
          if (!docUrl) return "";
          if (docUrl.startsWith("http")) {
            try {
              const url = new URL(docUrl);
              return `${url.origin}${url.pathname}`;
            } catch {
              return docUrl;
            }
          }
          return `${baseBlobUrl}${docUrl}`;
        };

        const fileName = getCleanDocUrl(rowData.doc_url);
        const url = `${API_URL}/${API_VERSION}/${DeleteUrl.deleteDocApplication}`;
        const token = localStorage.getItem("authToken");
        const obj = {
          application_id: applicationID,
          document_name: isFromBlobStorage(rowData.originalDocUrl)
            ? fileName
            : rowData.originalDocUrl,
          document_type: rowData.doc_type,
        };
        await axios.delete(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          data: obj,
        });

        // Remove from local state
        setMainData((prev: any[]) => {
          if (!prev || prev.length === 0) return prev;
          const newDocs = prev[0].additional_documents.filter((d: any) => {
            if (rowData.id) return d.id !== rowData.id;
            return (
              d.doc_url !== rowData.doc_url || d.doc_name !== rowData.doc_name
            );
          });
          return [
            {
              ...prev[0],
              additional_documents: newDocs,
            },
            ...prev.slice(1),
          ];
        });

        ToastService.success("Document removed successfully");
        fetchApplicationData();
      } else {
        ToastService.error(
          "This document cannot be deleted from here because it is not an additional document."
        );
      }
    } catch (err) {
      console.error("Delete failed", err);
      ToastService.error("Failed to remove document");
    }
  };

  const handleDeleteRow = async (rowData: any, name: any) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this entry from the application?"
    );
    if (!confirmDelete) return;
    try {
        const url = `${API_URL}/${API_VERSION}/${DeleteUrl.deleteApplicationRow}`;
        const token = localStorage.getItem("authToken");
        const obj = {
          application_id: applicationID,
          entry_type:  name,
          entry_id: rowData.id,
        };
        const response = await axios.delete(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          data: obj,
        });
        const successMessage = response.data;
        ToastService.success(successMessage);
        fetchApplicationData();
    } catch (err) {
      console.error("Delete failed", err);
      ToastService.error("Failed to remove document");
    }
  };

  const columns: TableColumn<FilesInterface>[] = [
    {
      field: "doc_url",
      header: "Preview",
      width: "10rem",
      filter: false,
      sortable: false,
      customBody: previewTemplate,
    },
    { field: "doc_name", header: "Document Name" },
    { field: "updatedDate", header: "Updated Date", width: "10rem" },
    {
      field: "action",
      header: "Action",
      width: "10rem",
      filter: false,
      sortable: false,
      customBody: actionTemplate,
    },
  ];
  const getDropdownApi = useGet<any>(`${GetUrl.getApplicationDropdown}`);
  const getApplicationData = useGet<any>(
    applicationID
      ? `${GetUrl.getApplication}?application_id=${applicationID}`
      : "",
    {},
    !!applicationID
  );
  const fetchApplicationData = async () => {
    showLoader();
    try {
      const result = await getApplicationData.refetch();
      if (result.data) {
        const updatedDocs = await secureAllDocuments(
          result?.data.additional_documents
        );

        // const filteredDocuments = updatedDocs.filter((item) => {
        //   const lowerCaseName = item.doc_url.toLowerCase();
        //   return hasValidExtensionInUrl(lowerCaseName) && item;
        // });
        // console.log('filteredDocuments', updatedDocs)
        setMainData([{ ...result.data, additional_documents: updatedDocs }]);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching app version:", error);
      hideLoader();
    } finally {
      hideLoader();
    }
  };
  const fetchDropdownData = async () => {
    try {
      const result = await getDropdownApi.refetch();
      if (result.data) {
        setDropDownData([result.data]);
      }
    } catch (error) {
      console.error("Error fetching app version:", error);
    }
  };
  useEffect(() => {
    if (applicationID) {
      fetchApplicationData();
      fetchDropdownData();
    }
  }, [applicationID]);
  const isFromBlobStorage = (docUrl: string): boolean => {
    const baseBlobUrl = `${BLOB_API}/documents/`;
    if (!docUrl) return false;
    return docUrl.startsWith(baseBlobUrl);
  };
  const mapMainDataToInitialValues = async (mainData: any) => {
    const data = mainData[0]; // Assuming array
    const titleList = [
      "Secondary Education",
      "Higher Secondary Education",
      "Graduation",
      "Post Graduation",
    ];
    const getSecure = async (fileName: string) => {
      if (!fileName) return "";
      return await getSecureBlobUrl({
        fileName,
        blobBaseUrl: BLOB_API,
        getTokenUrl: `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}`,
      });
    };

    const completedEducation = await Promise.all(
      data.completedEducation.map(async (edu: any, index: any) => ({
        id: edu.id || 0,
        title: edu.title || titleList[index] || "Completed Education",
        nameSchoolCollege: edu.institution,
        schoolCollegeAddress: edu.address,
        nameOfUniversity: edu.university_name,
        stream: edu.stream,
        course: edu.course,
        marksObtainedCGPA: edu.total_marks_cgpa,
        yearOfPassing: edu.year_of_passing,
        principalName: edu.principal_name,
        principalContactNumber: edu.principal_ph,
        uploadMarksheet: edu.marksheet_url,
        fileName: edu.marksheet_url,
        uploadMarksheetPreview: await getSecure(edu.marksheet_url),
        docName: edu.file_name,
      }))
    );

    const achievementsInfo = await Promise.all(
      data.achievements.map(async (ach: any) => ({
        id: ach.id,
        docName: ach.achievement,
        fileName: ach.supporting_doc_url,
        docFileName: ach.file_name,
        uploadPreview: await getSecure(ach.supporting_doc_url),
      }))
    );

    const uploadedDocuments = await Promise.all(
      data.additional_documents.map(async (doc: any) => ({
        id: doc.id,
        fileName: doc.doc_name,
        documentsPreview: await getSecure(doc.doc_url),
      }))
    );

    return {
      personalInfo: {
        firstName: data.personal_info.first_name,
        lastName: data.personal_info.last_name,
        email: data.personal_info.email,
        state: data.personal_info.state,
        city: data.personal_info.city,
        zipcode: data.personal_info.zipcode,
        mobileNumber: data.personal_info.phone,
        dateOfBirth: data.personal_info.dob,
        permanentHomeAddress: data.personal_info.home_address,
        district: data.personal_info.district,
        profilePhoto: await getSecure(data.personal_info.photo_url),
        profilePhotoName: data.personal_info.photo_url,
        socialMediaHandleFB: data.personal_info.facebook_url || "",
        socialMediaHandleInstagram: data.personal_info.instagram_url || "",
        socialMediaHandleLinkedIn: data.personal_info.linkedin_url || "",
        gender: data.personal_info.gender || "",
      },
      completedEducation,
      achievementsInfo,
      uploadedDocuments,
      familyDetails: {
        fathersName: data.family_details.father_name,
        mothersName: data.family_details.mother_name,
        guardiansName: data.family_details.guardian_name,
        fathersOccupation: data.family_details.father_occupation,
        mothersOccupation: data.family_details.mother_occupation,
        familyIncome: data.family_details.monthly_familiy_income,
        contactNumber: data.family_details.guardian_ph_number,
        siblings: data.family_details?.siblings?.map((s: any) => ({
          id: s.id,
          name: s.sibling_name,
          relationship: s.relationship,
          qualification: s.occupation,
          sisterHusbandName: s.sister_husband_name,
          sisterHusbandOccupation: s.sister_husband_occupation,
        })),
      },
      presentEducation: {
        id: data.presentEducation?.[0]?.id,
        nameSchoolorCollege: data.presentEducation?.[0]?.institution,
        schoolCollegeAddress: data.presentEducation?.[0]?.address,
        nameOfUniversity: data.presentEducation?.[0]?.university_name,
        stream: data.presentEducation?.[0]?.stream,
        course: data.presentEducation?.[0]?.course,
        yearOfAdmission: data.presentEducation?.[0]?.Year_of_Admission,
        currentSemester: data.presentEducation?.[0]?.Current_sem,
        courseDuration: data.presentEducation?.[0]?.Course_dur,
        principalName: data.presentEducation?.[0]?.principal_name,
        principalContactNumber: data.presentEducation?.[0]?.principal_ph,
        courseFees: data.presentEducation?.[0]?.Course_fee,
        paymentFrequency: data.presentEducation?.[0]?.Frequency_of_payment,
        totalFeesPaid: data.presentEducation?.[0]?.Fees_Already_paid || 0,
      },
      scholarshipPurpose: {
        knowApplication: data.scholarship_purpose?.source_of_infomation,
        purposeExplanation: data.scholarship_purpose?.scholarship_purpose,
        otherScholarships: data.scholarship_purpose?.other_scholarships?.map(
          (s: any) => ({
            id: s.id,
            scholarshipsName: s.scholarship_name,
            scholarshipsAmount: s.scholarship_amount,
          })
        ),
      },
      bankDetails: data.bank_details?.map((b: any) => ({
        id: b.id,
        title: b.title,
        bankName: b.bank_name,
        accountHolderName: b.account_holder_name,
        accountNumber: b.account_no,
        ifscCode: b.IFSC_no,
        branchName: b.branch,
        isPrimary: b.primary_indicator || false,
      })),
    };
  };
  useEffect(() => {
    const prepareData = async () => {
      if (mainData?.length > 0) {
        const selectedState = mainData[0]?.personal_info?.state;
        const selectedStateData = RegionArray.states.find(
          (state) => state.name === selectedState
        );
        setDistrictOptions(selectedStateData?.districts || []);
        const values = await mapMainDataToInitialValues(mainData);
        console.log("values", values);
        setInitialValues(values as any);
        setLoading(false);
      }
    };
    prepareData();
  }, [mainData]);
  const formik = useFormik({
    initialValues: initialValues || InitialValuesView,
    enableReinitialize: true,
    validationSchema: overallValidationSchema,
    onSubmit: (values) => {
      handleFinalSubmit();
    },
    validateOnBlur: true,
    validateOnChange: false,
  });

  const handleProfilePhotoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleFileUpload(
      event,
      "personalInfo.profilePhoto",
      "personalInfo.profilePhotoName"
    );
  };

  const handleMarksheetUploadChange = async (
    files: FileList | null,
    index: number
  ) => {
    setUploadingIndex(index);
    if (!files || files.length === 0) return;
    const uploadedBlobUrls: any[] = [];
    for (const file of Array.from(files)) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > MAX_FILE_SIZE_MB) {
        ToastService.error(`"${file.name}" exceeds the 5MB upload limit.`);
        formik.setFieldError(
          `completedEducation[${index}].uploadMarksheet`,
          `File size should not exceed ${MAX_FILE_SIZE_MB}MB`
        );
        setUploadingIndex(null);
        return; // stop further execution for this file
      }
      setUploading(true);
      try {
        const extension = file.name.split(".").pop()?.toLowerCase() || "pdf";
        const base64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result as string;
            resolve(result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

        const { data: sastokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${extension}`
        );

        const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
        const putRes = await axios.put(uploadUrl, buffer, configBlobToken);

        if (![200, 201].includes(putRes.status)) {
          console.warn(`Upload failed for ${file.name}`);
          continue;
        }

        const { data: accessTokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
        );

        const secureBlobUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
        const blobFileUrl = `${BLOB_API}/documents/${sastokenInfo.filename}`;
        uploadedBlobUrls.push({
          blobFileUrl: blobFileUrl,
          secureBlobUrl: secureBlobUrl,
          filename: sastokenInfo.filename,
          fileType: file.type,
          docName: file.name,
        });
        setUploading(false);
        ToastService.success("File upload successfully!");
      } catch (err) {
        setUploading(false);
        console.error("Upload failed:", err);
      } finally {
        setUploading(false);
        setUploadingIndex(null);
      }
    }

    // Step 3: Push to Formik – store the first uploaded URL as a string (or null)
    const updatedEducation = [...formik.values.completedEducation];
    updatedEducation[index] = {
      ...updatedEducation[index],
      uploadMarksheet:
        uploadedBlobUrls.length > 0
          ? uploadedBlobUrls[0].blobFileUrl
          : (null as any), // Store a single string URL or null
      fileName: uploadedBlobUrls[0].filename,
      uploadMarksheetPreview: uploadedBlobUrls[0].secureBlobUrl,
      fileType: uploadedBlobUrls[0].fileType,
      docName: uploadedBlobUrls[0].docName,
    };
    formik.setFieldValue("completedEducation", updatedEducation);
    const obj = {
      id: 0,
      doc_name: uploadedBlobUrls[0].docName,
      doc_url: uploadedBlobUrls[0].secureBlobUrl,
    };

    mainData[0]?.additional_documents.push(obj);
  };

  const handleDocumentUploadChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    console.log("event:", event);
    handleFileUpload(
      event,
      "uploadedDocuments.documentsPreview",
      "uploadedDocuments.fileName"
    );
    fileInputRef.current!.value = "";
  };
  const handleAchievementsUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    setUploadingIndex(index);
    const files: FileList | null = event.target.files;
    if (!files || files.length === 0) return;

    const uploadedBlobUrls: any[] = [];

    for (const file of Array.from(files)) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > MAX_FILE_SIZE_MB) {
        ToastService.error(`"${file.name}" exceeds the 5MB upload limit.`);
        formik.setFieldError(
          `achievementsInfo[${index}].uploadMarksheet`,
          `File size should not exceed ${MAX_FILE_SIZE_MB}MB`
        );
        setUploadingIndex(null);
        return; // stop further execution for this file
      }
      setUploading(true);
      try {
        const extension = file.name.split(".").pop()?.toLowerCase() || "pdf";

        const base64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result as string;
            resolve(result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

        const { data: sastokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${extension}`
        );

        const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
        const putRes = await axios.put(uploadUrl, buffer, configBlobToken);

        if (![200, 201].includes(putRes.status)) {
          console.warn(`Upload failed for ${file.name}`);
          continue;
        }

        const { data: accessTokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
        );

        const secureBlobUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
        const blobFileUrl = `${BLOB_API}/documents/${sastokenInfo.filename}`;

        uploadedBlobUrls.push({
          blobFileUrl: blobFileUrl,
          secureBlobUrl: secureBlobUrl,
          filename: sastokenInfo.filename,
          fileType: file.type,
          docName: file.name,
        });
        setUploading(false);
        ToastService.success("File upload successfully!");
      } catch (err) {
        console.error("Upload failed:", err);
      } finally {
        setUploading(false);
        setUploadingIndex(null);
      }
    }

    // Step 3: Push to Formik – store the first uploaded URL as a string (or null)
    const updatedEducation = [...formik.values.achievementsInfo];
    updatedEducation[index] = {
      ...updatedEducation[index],
      file:
        uploadedBlobUrls.length > 0
          ? uploadedBlobUrls[0].blobFileUrl
          : (null as any), // Store a single string URL or null
      fileName: uploadedBlobUrls[0].filename,
      uploadPreview: uploadedBlobUrls[0].secureBlobUrl,
      fileType: uploadedBlobUrls[0].fileType,
      docFileName: uploadedBlobUrls[0].docName,
    };
    formik.setFieldValue("achievementsInfo", updatedEducation);
    const obj = {
      id: 0,
      doc_name: formik.values.achievementsInfo[index].docName,
      doc_url: uploadedBlobUrls[0].secureBlobUrl,
    };

    mainData[0].additional_documents.push(obj);
  };

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    formikFieldPath: string,
    filePathName: string
  ) => {
    const file = event.currentTarget.files?.[0];
    if (!file) return;
    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > MAX_FILE_SIZE_MB) {
      ToastService.error(
        `"${file.name}" exceeds the ${MAX_FILE_SIZE_MB}MB upload limit.`
      );
      formik.setFieldError(
        formikFieldPath,
        `File size should not exceed ${MAX_FILE_SIZE_MB}MB`
      );
      return;
    }
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    setFileType(fileExtension || "");
    setUploading(true);
    try {
      const { data: sastokenInfo } = await axios.get(
        `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${fileExtension}`
      );

      const reader = new FileReader();

      reader.onloadend = async () => {
        const base64 = (reader.result as string).split(",")[1];
        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
        const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
        const imagePath = `${BLOB_API}/documents/${sastokenInfo.filename}`;
        const response = await axios.put(uploadUrl, buffer, configBlobToken);
        console.log("Upload response:", response);
        if (response.status === 200 || response.status === 201) {
          const { data: accessTokenInfo } = await axios.get(
            `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
          );
          const finalUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
          formik.setFieldValue(formikFieldPath, finalUrl);
          formik.setFieldValue(filePathName, sastokenInfo.filename);
          const obj = {
            id: 0,
            doc_name:
              filePathName === "uploadedDocuments.fileName"
                ? formik.values.uploadedDocuments.docName
                : file.name,
            doc_url: finalUrl,
          };
          setMainData((prev: any) =>
            prev.map((item: any, index: any) =>
              index === 0
                ? {
                    ...item,
                    additional_documents: [...item.additional_documents, obj],
                  }
                : item
            )
          );
        } else {
          console.error("Upload failed:", response.statusText);
        }
      };
      reader.readAsDataURL(file);
      setUploading(false);
      ToastService.success("File upload successfully!");
    } catch (error: any) {
      setUploading(false);
      if (axios.isAxiosError(error)) {
        console.error("Axios error:", error.response);
      } else {
        console.error("Upload failed:", error);
      }
    } finally {
      setUploading(false);
    }
  };
  const buildNestedTouched = (data: any): any => {
    if (Array.isArray(data)) {
      return data.map((item) => buildNestedTouched(item));
    }
    if (typeof data === "object" && data !== null) {
      const touched: Record<string, any> = {};
      for (const key in data) {
        const value = data[key];
        touched[key] =
          typeof value === "object" && value !== null
            ? buildNestedTouched(value)
            : true;
      }
      return touched;
    }
    return true;
  };

  const handleNext = async () => {
    let currentStepSchema;
    let valuesToValidate;
    let pathPrefix = "";
    if (formRef.current && isMobile) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    switch (activeStep) {
      case 0:
        currentStepSchema = personalInfoSchema;
        valuesToValidate = formik.values.personalInfo;
        pathPrefix = "personalInfo";
        break;
      case 1:
        currentStepSchema = yup.array().of(completedEducationItemSchema);
        valuesToValidate = formik.values.completedEducation;
        pathPrefix = "completedEducation";
        break;
      case 2:
        currentStepSchema = presentEducationSchema;
        valuesToValidate = formik.values.presentEducation;
        pathPrefix = "presentEducation";
        break;
      case 3:
        currentStepSchema = achievementItemSchema;
        valuesToValidate = formik.values.achievementsInfo;
        pathPrefix = "achievementsInfo";
        break;
      case 4:
        currentStepSchema = familyDetailsSchema;
        valuesToValidate = formik.values.familyDetails;
        pathPrefix = "familyDetails";
        break;
      case 5:
        currentStepSchema = scholarshipPurposeSchema;
        valuesToValidate = formik.values.scholarshipPurpose;
        pathPrefix = "scholarshipPurpose";
        break;
      case 6:
        currentStepSchema = bankDetailsSchema;
        valuesToValidate = formik.values.bankDetails;
        pathPrefix = "bankDetails";
        break;
      case 7:
        currentStepSchema = uploadedDocumentItemSchema;
        valuesToValidate = formik.values.uploadedDocuments;
        pathPrefix = "uploadedDocuments";
        break;
      default:
        currentStepSchema = yup.object();
        valuesToValidate = {};
        pathPrefix = "";
    }

    try {
      await currentStepSchema.validate(valuesToValidate, { abortEarly: false });

      if (activeStep < steps.length - 1) {
        setActiveStep((prev) => prev + 1);
      } else {
        // On final submit: touch everything
        const allTouched = buildNestedTouched(formik.values);
        formik.setTouched(allTouched, true);
        formik.handleSubmit();
      }
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        const errorMessages = err.inner
          .map((error) => error.message)
          .filter(Boolean)
          .join("\n");

        ToastService.error(`${errorMessages}`, {
          autoClose: false,
        });
      } else {
        ToastService.error("Please correct the errors before proceeding.");
      }

      // Touch only the current step's values
      const touchedFields = {
        [pathPrefix]: buildNestedTouched(valuesToValidate),
      };
      formik.setTouched(touchedFields, true);
    }
  };

  // Define the function outside handleNext
  const handleFinalSubmit = () => {
    // You can do additional validation or processing here if needed
    console.log("Final form values:", formik.values);
    patchAppCreateReq();
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedState = e.target.value;
    const selectedStateData = RegionArray.states.find(
      (state) => state.name === selectedState
    );
    setDistrictOptions(selectedStateData?.districts || []);

    formik.setFieldValue("personalInfo.state", selectedState);
    formik.setFieldValue("personalInfo.district", ""); // Reset district
  };

  // --- Step Content Rendering ---
  const getStepContent = (step: number) => {
    switch (step) {
      case 0: // Personal Info
        return (
          <>
            <Box className={styles.formContent}>
              {/* Left Column: Passport Photo */}
              <Box className={styles.passportPhotoColumn}>
                <Box className={styles.passportPhotoSection}>
                  <Avatar
                    alt="Passport Size Photo"
                    src={
                      typeof formik.values.personalInfo.profilePhoto ===
                      "string"
                        ? formik.values.personalInfo.profilePhoto
                        : formik.values.personalInfo.profilePhoto
                        ? URL.createObjectURL(
                            formik.values.personalInfo.profilePhoto
                          )
                        : placeholderImg
                    }
                    className={styles.avatar}
                  />
                  {formik.values.personalInfo.profilePhoto && (
                    <Button
                      size="small"
                      color="error"
                      className={"closeButton profilePhotoClose"}
                      onClick={() => {
                        formik.setFieldValue(`personalInfo.profilePhoto`, null);
                      }}
                    >
                      &#10006;
                    </Button>
                  )}
                  <Typography
                    variant="subtitle1"
                    className={styles.passportPhotoText}
                  >
                    Passport Size Photo
                  </Typography>
                  <Button
                    variant="contained"
                    component="label"
                    className={styles.browseButton}
                    disabled={appStatus}
                  >
                    Browse
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleProfilePhotoChange}
                      disabled={appStatus}
                    />
                  </Button>
                  {(formik.touched.personalInfo?.profilePhotoName ||
                    formik.submitCount > 0) &&
                    Boolean(formik.errors.personalInfo?.profilePhotoName) && (
                      <Typography color="error" variant="caption">
                        {formik.errors.personalInfo?.profilePhotoName as string}
                      </Typography>
                    )}
                </Box>
              </Box>

              {/* Right Column: Personal Info Fields */}
              <Box className={styles.personalInfoColumn}>
                <Typography
                  variant="h6"
                  className={styles.sectionTitle}
                  marginBottom={3}
                  display={"flex"}
                  justifyContent={"center"}
                >
                  <span>Personal Info</span>
                </Typography>
                <Box className={styles.fieldRow}>
                  <TextField
                    id="personalInfo.firstName"
                    name="personalInfo.firstName"
                    label="First Name *"
                    value={formik.values.personalInfo.firstName ?? ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.firstName ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.personalInfo?.firstName)
                    }
                    helperText={
                      (formik.touched.personalInfo?.firstName ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.firstName
                    }
                    className={styles.textFourField}
                    disabled={appStatus}
                  />
                  <TextField
                    id="personalInfo.lastName"
                    name="personalInfo.lastName"
                    label="Last Name *"
                    value={formik.values.personalInfo.lastName ?? ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.lastName ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.personalInfo?.lastName)
                    }
                    helperText={
                      (formik.touched.personalInfo?.lastName ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.lastName
                    }
                    className={styles.textFourField}
                    disabled={appStatus}
                  />
                  <TextField
                    select
                    id="personalInfo.gender"
                    name="personalInfo.gender"
                    label="Gender *"
                    value={formik.values.personalInfo.gender ?? ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.gender ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.personalInfo?.gender)
                    }
                    helperText={
                      (formik.touched.personalInfo?.gender ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.gender
                    }
                    className={styles.textFourField}
                    disabled={appStatus}
                  >
                    <MenuItem value="">Select Gender</MenuItem>
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </TextField>
                  <Box
                    className={styles.textFourField}
                    display="flex"
                    flexDirection="row"
                    gap={1}
                    alignItems={"center"}
                  >
                    <Box flexGrow={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            label="Date of Birth *"
                            views={["year", "month", "day"]}
                            format="DD-MM-YYYY"
                            value={
                              formik.values.personalInfo.dateOfBirth
                                ? dayjs(
                                    formik.values.personalInfo.dateOfBirth,
                                    "YYYY-MM-DD"
                                  )
                                : null
                            }
                            onChange={(date) => {
                              formik.setFieldValue(
                                `personalInfo.dateOfBirth`,
                                date && date.isValid()
                                  ? date.format("YYYY-MM-DD")
                                  : ""
                              );
                            }}
                            disableFuture
                            minDate={dayjs().subtract(100, "year")}
                            maxDate={dayjs().subtract(4, "year")}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error:
                                  (formik.touched.personalInfo?.dateOfBirth ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.personalInfo !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.personalInfo as any)
                                      ?.dateOfBirth
                                  ),
                                helperText:
                                  (formik.touched.personalInfo?.dateOfBirth ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.personalInfo !==
                                    "string" &&
                                  (formik.errors.personalInfo as any)
                                    ?.dateOfBirth,
                                InputLabelProps: { shrink: true },
                              },
                            }}
                            disabled={appStatus}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                    <Box display="flex" alignItems="center" mt={2}>
                      <Tooltip title="Minimum age should be 4 years." arrow>
                        <IconButton size="small">
                          <InfoOutlined fontSize="small" color="action" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
                <Box className={styles.fieldRow}>
                  <TextField
                    fullWidth
                    id="personalInfo.email"
                    name="personalInfo.email"
                    label="Email *"
                    value={formik.values.personalInfo.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.email ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.personalInfo?.email ?? "")
                    }
                    helperText={
                      formik.touched.personalInfo?.email &&
                      formik.errors.personalInfo?.email
                    }
                    className={styles.textFourField}
                    disabled={appStatus}
                  />
                  <TextField
                    fullWidth
                    id="personalInfo.mobileNumber"
                    name="personalInfo.mobileNumber"
                    label="Mobile Number *"
                    type="tel"
                    value={formik.values.personalInfo.mobileNumber ?? ""}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      if (val.length <= 10) {
                        formik.setFieldValue("personalInfo.mobileNumber", val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.mobileNumber ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.personalInfo?.mobileNumber)
                    }
                    helperText={
                      (formik.touched.personalInfo?.mobileNumber ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.mobileNumber
                    }
                    className={styles.textFourField}
                    disabled={true}
                  />
                </Box>
                <Box className={styles.fieldRow}>
                  <TextField
                    fullWidth
                    id="personalInfo.socialMediaHandleFB"
                    name="personalInfo.socialMediaHandleFB"
                    label="Facebook Handle"
                    value={formik.values.personalInfo.socialMediaHandleFB ?? ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.socialMediaHandleFB ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.personalInfo?.socialMediaHandleFB)
                    }
                    helperText={
                      (formik.touched.personalInfo?.socialMediaHandleFB ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.socialMediaHandleFB
                    }
                    className={styles.textThreeField}
                    disabled={appStatus}
                  />
                  <TextField
                    fullWidth
                    id="personalInfo.socialMediaHandleInstagram"
                    name="personalInfo.socialMediaHandleInstagram"
                    label="Instagram Handle"
                    value={
                      formik.values.personalInfo.socialMediaHandleInstagram ??
                      ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo
                        ?.socialMediaHandleInstagram ||
                        formik.submitCount > 0) &&
                      Boolean(
                        formik.errors.personalInfo?.socialMediaHandleInstagram
                      )
                    }
                    helperText={
                      (formik.touched.personalInfo
                        ?.socialMediaHandleInstagram ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.socialMediaHandleInstagram
                    }
                    className={styles.textThreeField}
                    disabled={appStatus}
                  />
                  <TextField
                    fullWidth
                    id="personalInfo.socialMediaHandleLinkedIn"
                    name="personalInfo.socialMediaHandleLinkedIn"
                    label="LinkedIn Handle"
                    value={
                      formik.values.personalInfo.socialMediaHandleLinkedIn ?? ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.socialMediaHandleLinkedIn ||
                        formik.submitCount > 0) &&
                      Boolean(
                        formik.errors.personalInfo?.socialMediaHandleLinkedIn
                      )
                    }
                    helperText={
                      (formik.touched.personalInfo?.socialMediaHandleLinkedIn ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.socialMediaHandleLinkedIn
                    }
                    className={styles.textThreeField}
                    disabled={appStatus}
                  />
                </Box>
                <Typography
                  variant="h6"
                  className={styles.sectionTitle}
                  marginBottom={3}
                  marginTop={3}
                  display={"flex"}
                  justifyContent={"center"}
                >
                  <span>Permanent Home Address</span>
                </Typography>
                <Box className={styles.fieldRow}>
                  <TextField
                    fullWidth
                    id="personalInfo.permanentHomeAddress"
                    name="personalInfo.permanentHomeAddress"
                    label="Permanent home address *"
                    value={
                      formik.values.personalInfo.permanentHomeAddress ?? ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.personalInfo?.permanentHomeAddress ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.personalInfo?.permanentHomeAddress)
                    }
                    helperText={
                      (formik.touched.personalInfo?.permanentHomeAddress ||
                        formik.submitCount > 0) &&
                      formik.errors.personalInfo?.permanentHomeAddress
                    }
                    className={styles.textThreeField}
                    multiline
                    rows={4}
                    disabled={appStatus}
                  />
                  <Box className={styles.textThreeField}>
                    <Box className={styles.fieldRow} flexWrap={"wrap"}>
                      <TextField
                        fullWidth
                        id="personalInfo.city"
                        name="personalInfo.city"
                        label="City *"
                        value={formik.values.personalInfo.city ?? ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          (formik.touched.personalInfo?.city ||
                            formik.submitCount > 0) &&
                          Boolean(formik.errors.personalInfo?.city)
                        }
                        helperText={
                          (formik.touched.personalInfo?.city ||
                            formik.submitCount > 0) &&
                          formik.errors.personalInfo?.city
                        }
                        className={styles.textField}
                        disabled={appStatus}
                      />

                      <TextField
                        fullWidth
                        select
                        id="personalInfo.state"
                        name="personalInfo.state"
                        label="State *"
                        value={formik.values.personalInfo.state ?? ""}
                        onChange={handleStateChange}
                        onBlur={formik.handleBlur}
                        error={
                          (formik.touched.personalInfo?.state ||
                            formik.submitCount > 0) &&
                          Boolean(formik.errors.personalInfo?.state)
                        }
                        helperText={
                          (formik.touched.personalInfo?.state ||
                            formik.submitCount > 0) &&
                          formik.errors.personalInfo?.state
                        }
                        className={styles.textField}
                        disabled={appStatus}
                      >
                        <MenuItem value="">Select State</MenuItem>
                        {RegionArray &&
                          RegionArray?.states?.map((item, index) => (
                            <MenuItem key={index} value={item.name}>
                              {item.name}
                            </MenuItem>
                          ))}
                      </TextField>
                      <TextField
                        fullWidth
                        select
                        id="personalInfo.district"
                        name="personalInfo.district"
                        label="District *"
                        value={formik.values.personalInfo.district ?? ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          (formik.touched.personalInfo?.district ||
                            formik.submitCount > 0) &&
                          Boolean(formik.errors.personalInfo?.district)
                        }
                        helperText={
                          (formik.touched.personalInfo?.district ||
                            formik.submitCount > 0) &&
                          formik.errors.personalInfo?.district
                        }
                        className={styles.textField}
                        disabled={appStatus}
                      >
                        <MenuItem value="">Select District</MenuItem>
                        {districtOptions.map((district, index) => (
                          <MenuItem key={index} value={district.name}>
                            {district.name}
                          </MenuItem>
                        ))}
                        {districtOptions.length > 0 && (
                          <MenuItem value={"Others"}>Others</MenuItem>
                        )}
                      </TextField>
                      <TextField
                        fullWidth
                        id="personalInfo.zipcode"
                        name="personalInfo.zipcode"
                        label="Zipcode *"
                        value={formik.values.personalInfo.zipcode || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          (formik.touched.personalInfo?.zipcode ||
                            formik.submitCount > 0) &&
                          Boolean(formik.errors.personalInfo?.zipcode)
                        }
                        helperText={
                          (formik.touched.personalInfo?.zipcode ||
                            formik.submitCount > 0) &&
                          formik.errors.personalInfo?.zipcode
                        }
                        slotProps={{
                          input: {
                            inputProps: {
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                              maxLength: 6,
                            },
                          },
                        }}
                        className={styles.textField}
                        disabled={appStatus}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        );

      case 1: // Completed Education
        return (
          <Box className={styles.educationSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Completed Education Details</span>
            </Typography>
            <FormikProvider value={formik}>
              <FieldArray name="completedEducation">
                {({ push, remove }) => (
                  <Box>
                    {formik.values.completedEducation.map(
                      (education, index) => (
                        <Accordion
                          key={index}
                          defaultExpanded
                          className={styles.accordion}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              variant="subtitle1"
                              className="accrodionHeading"
                            >
                              {education.course
                                ? education.course
                                : education.title}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box className={styles.fieldRow}>
                              <Box
                                className={`${styles.textFourField} ${styles.textFieldWidth}`}
                              >
                                <TextField
                                  fullWidth
                                  id={`completedEducation[${index}].nameSchoolCollege`}
                                  name={`completedEducation[${index}].nameSchoolCollege`}
                                  label="Name of School/Colleg *"
                                  value={education.nameSchoolCollege || ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    (formik.touched.completedEducation?.[index]
                                      ?.nameSchoolCollege ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.completedEducation?.[
                                      index
                                    ] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.nameSchoolCollege
                                    )
                                  }
                                  helperText={
                                    (formik.touched.completedEducation?.[index]
                                      ?.nameSchoolCollege ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.completedEducation?.[
                                      index
                                    ] !== "string" &&
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.nameSchoolCollege
                                  }
                                  multiline
                                  rows={4}
                                  disabled={appStatus}
                                />
                              </Box>
                              <Box
                                className={`${styles.textField} ${styles.textFieldWidth}`}
                              >
                                <Box className={styles.fieldRow}>
                                  <TextField
                                    fullWidth
                                    id={`completedEducation[${index}].schoolCollegeAddress`}
                                    name={`completedEducation[${index}].schoolCollegeAddress`}
                                    label="School/College Address *"
                                    value={education.schoolCollegeAddress || ""}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.schoolCollegeAddress ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.schoolCollegeAddress
                                      )
                                    }
                                    helperText={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.schoolCollegeAddress ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.schoolCollegeAddress
                                    }
                                    disabled={appStatus}
                                  />
                                </Box>
                                <Box className={styles.fieldRow}>
                                  <TextField
                                    id={`completedEducation[${index}].nameOfUniversity`}
                                    name={`completedEducation[${index}].nameOfUniversity`}
                                    label="Name of Board/University *"
                                    value={education.nameOfUniversity || ""}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.nameOfUniversity ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.nameOfUniversity
                                      )
                                    }
                                    helperText={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.nameOfUniversity ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.nameOfUniversity
                                    }
                                    className={styles.textAutoField}
                                    disabled={appStatus}
                                  />
                                  <TextField
                                    id={`completedEducation[${index}].course`}
                                    name={`completedEducation[${index}].course`}
                                    label="Standard *"
                                    select
                                    value={education.course || ""}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      // Set title to the same value as course
                                      formik.setFieldValue(
                                        `completedEducation[${index}].title`,
                                        e.target.value
                                      );
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.course ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.course
                                      )
                                    }
                                    helperText={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.course ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.course
                                    }
                                    className={styles.textAutoField}
                                    disabled={appStatus}
                                  >
                                    <MenuItem value="">
                                      Select Standard
                                    </MenuItem>
                                    {dropDownData &&
                                      dropDownData[0]?.courses.map((label) => (
                                        <MenuItem key={label} value={label}>
                                          {label}
                                        </MenuItem>
                                      ))}
                                  </TextField>
                                  <TextField
                                    id={`completedEducation[${index}].stream`}
                                    name={`completedEducation[${index}].stream`}
                                    label="Stream *"
                                    select
                                    value={education.stream || ""}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      // Set title to the same value as stream
                                      formik.setFieldValue(
                                        `completedEducation[${index}].title`,
                                        e.target.value
                                      );
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.stream ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.stream
                                      )
                                    }
                                    helperText={
                                      (formik.touched.completedEducation?.[
                                        index
                                      ]?.stream ||
                                        formik.submitCount > 0) &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.stream
                                    }
                                    className={styles.textAutoField}
                                    disabled={appStatus}
                                  >
                                    <MenuItem value="">Select Stream</MenuItem>
                                    {dropDownData &&
                                      dropDownData[0]?.streams.map((label) => (
                                        <MenuItem key={label} value={label}>
                                          {label}
                                        </MenuItem>
                                      ))}
                                  </TextField>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DemoContainer components={["DatePicker"]}>
                                      <DatePicker
                                        label="Year of Passing *"
                                        views={["year"]}
                                        value={
                                          education.yearOfPassing
                                            ? dayjs(
                                                education.yearOfPassing,
                                                "YYYY"
                                              )
                                            : null
                                        }
                                        onChange={(date) => {
                                          formik.setFieldValue(
                                            `completedEducation[${index}].yearOfPassing`,
                                            date && date.isValid()
                                              ? date.format("YYYY")
                                              : ""
                                          );
                                        }}
                                        slotProps={{
                                          textField: {
                                            fullWidth: true,
                                            error:
                                              (formik.touched
                                                .completedEducation?.[index]
                                                ?.yearOfPassing ||
                                                formik.submitCount > 0) &&
                                              typeof formik.errors
                                                .completedEducation?.[index] !==
                                                "string" &&
                                              Boolean(
                                                (
                                                  formik.errors
                                                    .completedEducation?.[
                                                    index
                                                  ] as any
                                                )?.yearOfPassing
                                              ),
                                            helperText:
                                              (formik.touched
                                                .completedEducation?.[index]
                                                ?.yearOfPassing ||
                                                formik.submitCount > 0) &&
                                              typeof formik.errors
                                                .completedEducation?.[index] !==
                                                "string" &&
                                              (
                                                formik.errors
                                                  .completedEducation?.[
                                                  index
                                                ] as any
                                              )?.yearOfPassing,
                                            InputLabelProps: { shrink: true },
                                            className: styles.textAutoField,
                                          },
                                        }}
                                        disabled={appStatus}
                                      />
                                    </DemoContainer>
                                  </LocalizationProvider>
                                </Box>
                              </Box>
                            </Box>
                            <Box className={styles.fieldRow}>
                              <TextField
                                fullWidth
                                id={`completedEducation[${index}].marksObtainedCGPA`}
                                name={`completedEducation[${index}].marksObtainedCGPA`}
                                label="Marks Obtained/CGPA *"
                                type="number"
                                value={education.marksObtainedCGPA || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  (formik.touched.completedEducation?.[index]
                                    ?.marksObtainedCGPA ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.marksObtainedCGPA
                                  )
                                }
                                helperText={
                                  (formik.touched.completedEducation?.[index]
                                    ?.marksObtainedCGPA ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.completedEducation?.[
                                      index
                                    ] as any
                                  )?.marksObtainedCGPA
                                }
                                className={styles.textFourField}
                                disabled={appStatus}
                              />

                              <TextField
                                fullWidth
                                id={`completedEducation[${index}].principalName`}
                                name={`completedEducation[${index}].principalName`}
                                label="Principal's Name *"
                                value={education.principalName || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  (formik.touched.completedEducation?.[index]
                                    ?.principalName ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.principalName
                                  )
                                }
                                helperText={
                                  (formik.touched.completedEducation?.[index]
                                    ?.principalName ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.completedEducation?.[
                                      index
                                    ] as any
                                  )?.principalName
                                }
                                className={styles.textFourField}
                                disabled={appStatus}
                              />
                              <TextField
                                fullWidth
                                id={`completedEducation[${index}].principalContactNumber`}
                                name={`completedEducation[${index}].principalContactNumber`}
                                label="Principal's Contact Number *"
                                value={education.principalContactNumber || ""}
                                type="tel"
                                onChange={(e) => {
                                  const val = e.target.value.replace(/\D/g, "");
                                  if (val.length <= 11) {
                                    formik.setFieldValue(
                                      `completedEducation[${index}].principalContactNumber`,
                                      val
                                    );
                                  }
                                }}
                                onBlur={formik.handleBlur}
                                error={
                                  (formik.touched.completedEducation?.[index]
                                    ?.principalContactNumber ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.principalContactNumber
                                  )
                                }
                                helperText={
                                  (formik.touched.completedEducation?.[index]
                                    ?.principalContactNumber ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.completedEducation?.[
                                      index
                                    ] as any
                                  )?.principalContactNumber
                                }
                                className={styles.textFourField}
                                disabled={appStatus}
                              />
                            </Box>
                            <Box className={styles.fieldRow}>
                              <Box className={styles.fileUploadField}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{ mb: 0 }}
                                  paddingBottom={"0.25rem"}
                                >
                                  Upload Marksheet
                                </Typography>
                                <Box display={"flex"} alignItems={"center"}>
                                  <Button
                                    variant="contained"
                                    component="label"
                                    className={styles.commonBtn}
                                    sx={{ flex: "none", marginRight: "1rem" }}
                                    disabled={appStatus}
                                  >
                                    Choose File
                                    <input
                                      type="file"
                                      hidden
                                      onChange={(e) =>
                                        handleMarksheetUploadChange(
                                          e.target.files,
                                          index
                                        )
                                      }
                                      disabled={appStatus}
                                    />
                                  </Button>
                                  <Typography variant="body2">
                                    {education.uploadMarksheet
                                      ? education.docName || education.fileName
                                      : "No file chosen"}
                                  </Typography>
                                  {education.uploadMarksheetPreview && (
                                    <Button
                                      size="small"
                                      color="error"
                                      className={"closeButton"}
                                      onClick={() => {
                                        formik.setFieldValue(
                                          `completedEducation[${index}].uploadMarksheetPreview`,
                                          null
                                        );
                                        formik.setFieldValue(
                                          `completedEducation[${index}].docName`,
                                          null
                                        );
                                        formik.setFieldValue(
                                          `completedEducation[${index}].fileName`,
                                          null
                                        );
                                      }}
                                    >
                                      &#10006;
                                    </Button>
                                  )}
                                  {uploadingIndex === index && uploading && (
                                    <Box className={styles.smallLoader} ml={2}>
                                      <CircularProgress size={24} />
                                    </Box>
                                  )}
                                </Box>
                                {(formik.touched.completedEducation?.[index]
                                  ?.uploadMarksheet ||
                                  formik.submitCount > 0) &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.uploadMarksheet
                                  ) && (
                                    <Typography color="error" variant="caption">
                                      {
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.uploadMarksheet as string
                                      }
                                    </Typography>
                                  )}
                                {education.fileType === "application/pdf" ||
                                education?.fileName?.includes(".pdf") ? (
                                  <Box
                                    onClick={() => {
                                      filePreviewHandler(
                                        education,
                                        "completedEducation"
                                      );
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={pdfplaceholderImg}
                                      alt="Document Preview"
                                      style={{
                                        width: "10rem",
                                        height: "auto",
                                        borderRadius: "4px",
                                        objectFit: "cover",
                                        boxShadow: "0 0 6px rgba(0,0,0,0.1)",
                                        marginTop: "1rem",
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <>
                                    <Box
                                      onClick={() => {
                                        filePreviewHandler(
                                          education,
                                          "completedEducation"
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                      mt={1}
                                    >
                                      <img
                                        src={
                                          typeof education.uploadMarksheetPreview ===
                                          "string"
                                            ? education.uploadMarksheetPreview
                                            : education.uploadMarksheetPreview
                                            ? URL.createObjectURL(
                                                education.uploadMarksheetPreview
                                              )
                                            : placeholderImg
                                        }
                                        alt="Preview"
                                        style={{
                                          maxHeight: 150,
                                          borderRadius: 8,
                                        }}
                                      />
                                    </Box>
                                  </>
                                )}
                              </Box>
                            </Box>
                            {formik.values.completedEducation.length > 1 &&
                              !appStatus && (
                                <Button
                                  startIcon={<RemoveCircleOutlineIcon />}
                                  color="error"
                                  onClick={() => {
                                    // const filter =
                                    //   mainData[0].additional_documents.filter(
                                    //     (doc) =>
                                    //       doc.doc_name !==
                                    //       formik.values.completedEducation[
                                    //         index
                                    //       ].docName
                                    //   );
                                    // setMainData([
                                    //   {
                                    //     ...mainData[0],
                                    //     additional_documents: filter as any,
                                    //   },
                                    // ]);
                                    remove(index);
                                    handleDeleteRow(formik.values.completedEducation[index], 'education');
                                  }}
                                  className={styles.removeButton}
                                >
                                  Remove
                                </Button>
                              )}
                          </AccordionDetails>
                        </Accordion>
                      )
                    )}
                    {!appStatus && (
                      <Box
                        padding={2}
                        display={"flex"}
                        justifyContent={"flex-end"}
                      >
                        <Button
                          startIcon={<AddCircleOutlineIcon />}
                          variant="contained"
                          onClick={() =>
                            push({
                              id: 0,
                              title: "New Education",
                              nameSchoolCollege: "",
                              schoolCollegeAddress: "",
                              nameOfUniversity: "",
                              course: "",
                              stream: "",
                              marksObtainedCGPA: "",
                              yearOfPassing: "",
                              principalName: "",
                              principalContactNumber: "",
                              uploadMarksheet: null,
                            })
                          }
                          className={styles.commonBtn}
                        >
                          Add More Education
                        </Button>
                      </Box>
                    )}
                    {formik.touched.completedEducation &&
                      typeof formik.errors.completedEducation === "string" && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{ mt: 1 }}
                        >
                          {formik.errors.completedEducation}
                        </Typography>
                      )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 2: // Present Education
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Present Education Details</span>
            </Typography>
            <Typography variant="body2" align="center" marginBottom={4}>
              Please provide your present course details for which you are
              applying for scholarship..
            </Typography>
            <Box className={styles.fieldRow}>
              <TextField
                fullWidth
                id="presentEducation.nameSchoolorCollege"
                name="presentEducation.nameSchoolorCollege"
                label="Name of School/College *"
                value={formik.values.presentEducation.nameSchoolorCollege || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.nameSchoolorCollege ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.presentEducation?.nameSchoolorCollege)
                }
                helperText={
                  (formik.touched.presentEducation?.nameSchoolorCollege ||
                    formik.submitCount > 0) &&
                  formik.errors.presentEducation?.nameSchoolorCollege
                }
                className={styles.textFourField}
                disabled={appStatus}
                multiline
                rows={4}
              />
              <Box className={styles.textField}>
                <Box className={styles.fieldRow} flexWrap={"wrap"}>
                  <TextField
                    fullWidth
                    id="presentEducation.schoolCollegeAddress"
                    name="presentEducation.schoolCollegeAddress"
                    label="School/College Address *"
                    value={
                      formik.values.presentEducation.schoolCollegeAddress || ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.presentEducation?.schoolCollegeAddress ||
                        formik.submitCount > 0) &&
                      Boolean(
                        formik.errors.presentEducation?.schoolCollegeAddress
                      )
                    }
                    helperText={
                      (formik.touched.presentEducation?.schoolCollegeAddress ||
                        formik.submitCount > 0) &&
                      formik.errors.presentEducation?.schoolCollegeAddress
                    }
                    disabled={appStatus}
                  />
                  <TextField
                    fullWidth
                    id="presentEducation.nameOfUniversity"
                    name="presentEducation.nameOfUniversity"
                    label="Name of Board/University *"
                    value={
                      formik.values.presentEducation.nameOfUniversity || ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.presentEducation?.nameOfUniversity ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.presentEducation?.nameOfUniversity)
                    }
                    helperText={
                      (formik.touched.presentEducation?.nameOfUniversity ||
                        formik.submitCount > 0) &&
                      formik.errors.presentEducation?.nameOfUniversity
                    }
                    className={styles.textFourField}
                    disabled={appStatus}
                  />

                  <TextField
                    fullWidth
                    id="presentEducation.course"
                    name="presentEducation.course"
                    label="Standard *"
                    select
                    value={formik.values.presentEducation.course || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.presentEducation?.course ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.presentEducation?.course)
                    }
                    helperText={
                      (formik.touched.presentEducation?.course ||
                        formik.submitCount > 0) &&
                      formik.errors.presentEducation?.course
                    }
                    className={styles.textFourField}
                    disabled={appStatus}
                  >
                    <MenuItem value="">Select Standard</MenuItem>
                    {dropDownData &&
                      dropDownData[0]?.courses.map((label) => (
                        <MenuItem key={label} value={label}>
                          {label}
                        </MenuItem>
                      ))}
                  </TextField>
                  <TextField
                    fullWidth
                    id="presentEducation.stream"
                    name="presentEducation.stream"
                    label="Stream *"
                    select
                    value={formik.values.presentEducation.stream || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.presentEducation?.stream ||
                        formik.submitCount > 0) &&
                      Boolean(formik.errors.presentEducation?.stream)
                    }
                    helperText={
                      (formik.touched.presentEducation?.stream ||
                        formik.submitCount > 0) &&
                      formik.errors.presentEducation?.stream
                    }
                    className={styles.textFourField}
                    disabled={appStatus}
                  >
                    <MenuItem value="">Select Stream</MenuItem>
                    {dropDownData &&
                      dropDownData[0]?.streams.map((label) => (
                        <MenuItem key={label} value={label}>
                          {label}
                        </MenuItem>
                      ))}
                  </TextField>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        label="Year of Admissions *"
                        views={["year"]}
                        value={
                          formik.values.presentEducation.yearOfAdmission
                            ? dayjs(
                                formik.values.presentEducation.yearOfAdmission,
                                "YYYY"
                              )
                            : null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `presentEducation.yearOfAdmission`,
                            date && date.isValid() ? date.format("YYYY") : ""
                          );
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              (formik.touched.presentEducation
                                ?.yearOfAdmission ||
                                formik.submitCount > 0) &&
                              typeof formik.errors.presentEducation !==
                                "string" &&
                              Boolean(
                                (formik.errors.presentEducation as any)
                                  ?.yearOfAdmission
                              ),
                            helperText:
                              (formik.touched.presentEducation
                                ?.yearOfAdmission ||
                                formik.submitCount > 0) &&
                              typeof formik.errors.presentEducation !==
                                "string" &&
                              (formik.errors.presentEducation as any)
                                ?.yearOfAdmission,
                            InputLabelProps: { shrink: true },
                            className: styles.textFourField,
                          },
                        }}
                        disabled={appStatus}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Box>
              </Box>
            </Box>
            <Box className={styles.fieldRow} flexWrap={"wrap"}>
              <TextField
                fullWidth
                select
                id="presentEducation.currentSemester"
                name="presentEducation.currentSemester"
                label="Current Semester (if applicable) *"
                value={formik.values.presentEducation.currentSemester || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.currentSemester ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.presentEducation?.currentSemester)
                }
                helperText={
                  (formik.touched.presentEducation?.currentSemester ||
                    formik.submitCount > 0) &&
                  formik.errors.presentEducation?.currentSemester
                }
                className={styles.textFourField}
                disabled={appStatus}
              >
                <MenuItem value="">Select Semester</MenuItem>
                {Semesters.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item} Semester
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                id="presentEducation.courseDuration"
                name="presentEducation.courseDuration"
                label="Course Duration *"
                value={formik.values.presentEducation.courseDuration || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.courseDuration ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.presentEducation?.courseDuration)
                }
                helperText={
                  (formik.touched.presentEducation?.courseDuration ||
                    formik.submitCount > 0) &&
                  formik.errors.presentEducation?.courseDuration
                }
                className={styles.textFourField}
                disabled={appStatus}
              >
                <MenuItem value="">Select Course</MenuItem>
                {Durations.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                id="presentEducation.principalName"
                name="presentEducation.principalName"
                label="Principal's Name *"
                value={formik.values.presentEducation.principalName || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.principalName ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.presentEducation?.principalName)
                }
                helperText={
                  formik.touched.presentEducation?.principalName &&
                  formik.errors.presentEducation?.principalName
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
              <TextField
                fullWidth
                id="presentEducation.principalContactNumber"
                name="presentEducation.principalContactNumber"
                label="Principal's Contact Number *"
                type="tel"
                value={
                  formik.values.presentEducation.principalContactNumber || ""
                }
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "");
                  if (val.length <= 11) {
                    formik.setFieldValue(
                      `presentEducation.principalContactNumber`,
                      val
                    );
                  }
                }}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.principalContactNumber ||
                    formik.submitCount > 0) &&
                  Boolean(
                    formik.errors.presentEducation?.principalContactNumber
                  )
                }
                helperText={
                  (formik.touched.presentEducation?.principalContactNumber ||
                    formik.submitCount > 0) &&
                  formik.errors.presentEducation?.principalContactNumber
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
              <TextField
                fullWidth
                id="presentEducation.courseFees"
                name="presentEducation.courseFees"
                label="Course Fees *"
                value={formik.values.presentEducation.courseFees || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.courseFees ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.presentEducation?.courseFees)
                }
                helperText={
                  (formik.touched.presentEducation?.courseFees ||
                    formik.submitCount > 0) &&
                  formik.errors.presentEducation?.courseFees
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
              <TextField
                fullWidth
                select
                id="presentEducation.paymentFrequency"
                name="presentEducation.paymentFrequency"
                label="Frequency of Payment *"
                value={formik.values.presentEducation.paymentFrequency || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.paymentFrequency ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.presentEducation?.paymentFrequency)
                }
                helperText={
                  (formik.touched.presentEducation?.paymentFrequency ||
                    formik.submitCount > 0) &&
                  formik.errors.presentEducation?.paymentFrequency
                }
                className={styles.textFourField}
                disabled={appStatus}
              >
                <MenuItem value="">Select Frequency</MenuItem>
                {Frequencies.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                id="presentEducation.totalFeesPaid"
                name="presentEducation.totalFeesPaid"
                label="Total Fees Already Paid *"
                value={formik.values.presentEducation.totalFeesPaid || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.presentEducation?.totalFeesPaid ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.presentEducation?.totalFeesPaid)
                }
                helperText={
                  (formik.touched.presentEducation?.totalFeesPaid ||
                    formik.submitCount > 0) &&
                  formik.errors.presentEducation?.totalFeesPaid
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
            </Box>
          </Box>
        );

      case 3: // Achievements
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Achievements</span>
            </Typography>
            <Typography variant="body2" align="center" marginBottom={4}>
              Please provide details of any of your achievements. (e.g
              Represented India at international events or secured a state-level
              rank in the board examinations.)
            </Typography>
            <FormikProvider value={formik}>
              <FieldArray name="achievementsInfo">
                {({ push, remove }) => (
                  <Box>
                    {formik.values.achievementsInfo.map(
                      (Achievement, index) => (
                        <Accordion
                          key={index}
                          defaultExpanded
                          className={styles.accordion}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              variant="subtitle1"
                              className="accrodionHeading"
                            >
                              Achievement {index + 1}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box
                              className={`${styles.fieldRow} ${styles.fieldRowOth}`}
                            >
                              <TextField
                                fullWidth
                                id={`achievementsInfo[${index}].docName`}
                                name={`achievementsInfo[${index}].docName`}
                                label="Achievement"
                                value={Achievement.docName || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  (formik.touched.achievementsInfo?.[index]
                                    ?.docName ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.achievementsInfo?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.achievementsInfo?.[
                                        index
                                      ] as any
                                    )?.docName
                                  )
                                }
                                helperText={
                                  (formik.touched.achievementsInfo?.[index]
                                    ?.docName ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.achievementsInfo?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.achievementsInfo?.[
                                      index
                                    ] as any
                                  )?.docName
                                }
                                className={styles.textNoneField}
                                sx={{ width: "auto" }}
                                disabled={appStatus}
                              />

                              <Box className={styles.fileUploadField}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{ mb: 0 }}
                                  paddingBottom={"0.25rem"}
                                >
                                  Supporting Document
                                </Typography>
                                <Box display={"flex"} alignItems={"center"}>
                                  <Button
                                    variant="contained"
                                    component="label"
                                    className={styles.commonBtn}
                                    sx={{ marginRight: "1rem" }}
                                    disabled={appStatus}
                                  >
                                    Choose File
                                    <input
                                      type="file"
                                      hidden
                                      onChange={(e) =>
                                        handleAchievementsUpload(e, index)
                                      }
                                      disabled={appStatus}
                                    />
                                  </Button>
                                  <Typography variant="body2">
                                    {Achievement.fileName
                                      ? Achievement.docFileName
                                      : "No file chosen"}
                                  </Typography>
                                  {Achievement.uploadPreview && (
                                    <Button
                                      size="small"
                                      color="error"
                                      className={"closeButton"}
                                      onClick={() => {
                                        formik.setFieldValue(
                                          `achievementsInfo[${index}].uploadPreview`,
                                          null
                                        );
                                        formik.setFieldValue(
                                          `achievementsInfo[${index}].docFileName`,
                                          null
                                        );
                                        formik.setFieldValue(
                                          `achievementsInfo[${index}].fileName`,
                                          null
                                        );
                                      }}
                                    >
                                      &#10006;
                                    </Button>
                                  )}
                                  {uploadingIndex === index && uploading && (
                                    <Box className={styles.smallLoader} ml={2}>
                                      <CircularProgress size={24} />
                                    </Box>
                                  )}
                                </Box>
                                {(formik.touched.achievementsInfo?.[index]
                                  ?.file ||
                                  formik.submitCount > 0) &&
                                  typeof formik.errors.achievementsInfo?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.achievementsInfo?.[
                                        index
                                      ] as any
                                    )?.file
                                  ) && (
                                    <Typography color="error" variant="caption">
                                      {
                                        (
                                          formik.errors.achievementsInfo?.[
                                            index
                                          ] as any
                                        )?.file as string
                                      }
                                    </Typography>
                                  )}
                                {Achievement.fileType === "application/pdf" ||
                                Achievement?.fileName?.includes(".pdf") ? (
                                  <Box
                                    onClick={() => {
                                      filePreviewHandler(
                                        Achievement,
                                        "achievementsInfo"
                                      );
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={pdfplaceholderImg}
                                      alt="Document Preview"
                                      style={{
                                        width: "10rem",
                                        height: "auto",
                                        borderRadius: "4px",
                                        objectFit: "cover",
                                        boxShadow: "0 0 6px rgba(0,0,0,0.1)",
                                        marginTop: "1rem",
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <>
                                    <Box
                                      mt={1}
                                      onClick={() => {
                                        filePreviewHandler(
                                          Achievement,
                                          "achievementsInfo"
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src={
                                          typeof Achievement.uploadPreview ===
                                          "string"
                                            ? Achievement.uploadPreview.trim() !==
                                              ""
                                              ? Achievement.uploadPreview
                                              : placeholderImg
                                            : Achievement.uploadPreview
                                            ? URL.createObjectURL(
                                                Achievement.uploadPreview
                                              )
                                            : placeholderImg
                                        }
                                        alt="Preview"
                                        style={{
                                          maxHeight: 150,
                                          borderRadius: 8,
                                        }}
                                      />
                                    </Box>
                                  </>
                                )}
                              </Box>
                            </Box>
                            {formik.values.achievementsInfo.length > 1 &&
                              !appStatus && (
                                <Button
                                  startIcon={<RemoveCircleOutlineIcon />}
                                  color="error"
                                  onClick={() => {
                                    const filter =
                                      mainData[0].additional_documents.filter(
                                        (doc) =>
                                          doc.doc_name !==
                                          formik.values.achievementsInfo[index]
                                            .docName
                                      );
                                    setMainData([
                                      {
                                        ...mainData[0],
                                        additional_documents: filter as any,
                                      },
                                    ]);
                                    remove(index);
                                  }}
                                  className={styles.removeButton}
                                >
                                  Remove
                                </Button>
                              )}
                          </AccordionDetails>
                        </Accordion>
                      )
                    )}
                    {!appStatus && (
                      <Box
                        padding={2}
                        display={"flex"}
                        justifyContent={"flex-end"}
                      >
                        <Button
                          startIcon={<AddCircleOutlineIcon />}
                          variant="contained"
                          onClick={() =>
                            push({
                              id: 0,
                              fileName: "",
                              file: "",
                            })
                          }
                          className={styles.commonBtn}
                        >
                          Add More Achievement
                        </Button>
                      </Box>
                    )}
                    {(formik.touched.completedEducation ||
                      formik.submitCount > 0) &&
                      typeof formik.errors.completedEducation === "string" && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{ mt: 1 }}
                        >
                          {formik.errors.completedEducation}
                        </Typography>
                      )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 4: // Family Details
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={2}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Family Details</span>
            </Typography>
            <Typography variant="body2" align="center" marginBottom={2}>
              Please provide details of your family members.
            </Typography>

            <Box className={styles.fieldRow}>
              <TextField
                fullWidth
                id="familyDetails.fathersName"
                name="familyDetails.fathersName"
                label="Father's Name *"
                value={formik.values.familyDetails.fathersName || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.familyDetails?.fathersName ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.familyDetails?.fathersName)
                }
                helperText={
                  (formik.touched.familyDetails?.fathersName ||
                    formik.submitCount > 0) &&
                  formik.errors.familyDetails?.fathersName
                }
                className={styles.textFourField}
                disabled={appStatus}
              />

              <TextField
                fullWidth
                id="familyDetails.mothersName"
                name="familyDetails.mothersName"
                label="Mother's Name *"
                value={formik.values.familyDetails.mothersName || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.familyDetails?.mothersName ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.familyDetails?.mothersName)
                }
                helperText={
                  (formik.touched.familyDetails?.mothersName ||
                    formik.submitCount > 0) &&
                  formik.errors.familyDetails?.mothersName
                }
                className={styles.textFourField}
                disabled={appStatus}
              />

              <TextField
                fullWidth
                id="familyDetails.guardiansName"
                name="familyDetails.guardiansName"
                label="Father’s/Guardian’s Name *"
                value={formik.values.familyDetails.guardiansName || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.familyDetails?.guardiansName ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.familyDetails?.guardiansName)
                }
                helperText={
                  (formik.touched.familyDetails?.guardiansName ||
                    formik.submitCount > 0) &&
                  formik.errors.familyDetails?.guardiansName
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
            </Box>

            <Box className={styles.fieldRow}>
              <TextField
                fullWidth
                id="familyDetails.fathersOccupation"
                name="familyDetails.fathersOccupation"
                label="Occupation of Father *"
                value={formik.values.familyDetails.fathersOccupation || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.familyDetails?.fathersOccupation ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.familyDetails?.fathersOccupation)
                }
                helperText={
                  (formik.touched.familyDetails?.fathersOccupation ||
                    formik.submitCount > 0) &&
                  formik.errors.familyDetails?.fathersOccupation
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
              <TextField
                fullWidth
                id="familyDetails.mothersOccupation"
                name="familyDetails.mothersOccupation"
                label="Occupation of Mother *"
                value={formik.values.familyDetails.mothersOccupation || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.familyDetails?.mothersOccupation ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.familyDetails?.mothersOccupation)
                }
                helperText={
                  (formik.touched.familyDetails?.mothersOccupation ||
                    formik.submitCount > 0) &&
                  formik.errors.familyDetails?.mothersOccupation
                }
                className={styles.textFourField}
                disabled={appStatus}
              />

              <TextField
                fullWidth
                id="familyDetails.contactNumber"
                name="familyDetails.contactNumber"
                label="Father's/Guardian's Contact No. *"
                value={formik.values.familyDetails.contactNumber || ""}
                type="tel"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "");
                  if (val.length <= 10) {
                    formik.setFieldValue(`familyDetails.contactNumber`, val);
                  }
                }}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.familyDetails?.contactNumber ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.familyDetails?.contactNumber)
                }
                helperText={
                  (formik.touched.familyDetails?.contactNumber ||
                    formik.submitCount > 0) &&
                  formik.errors.familyDetails?.contactNumber
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
              <TextField
                fullWidth
                id="familyDetails.familyIncome"
                name="familyDetails.familyIncome"
                label="Monthly Family Income *"
                type="number"
                value={formik.values.familyDetails.familyIncome || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.familyDetails?.familyIncome ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.familyDetails?.familyIncome)
                }
                helperText={
                  (formik.touched.familyDetails?.familyIncome ||
                    formik.submitCount > 0) &&
                  formik.errors.familyDetails?.familyIncome
                }
                className={styles.textFourField}
                disabled={appStatus}
              />
            </Box>

            <FormikProvider value={formik}>
              <FieldArray name="familyDetails.siblings">
                {({ push, remove }) => (
                  <Box paddingTop={3}>
                    <Typography
                      variant="h6"
                      className={styles.sectionTitle}
                      marginBottom={2}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <span>Siblings Details</span>
                    </Typography>
                    <Typography variant="body2" align="center" marginBottom={2}>
                      Please provide details of your siblings if applicable.
                    </Typography>
                    {formik.values.familyDetails.siblings.map(
                      (sibling, index) => {
                        const isSister =
                          sibling.relationship?.toLowerCase() === "sister";
                        return (
                          <Accordion
                            key={index}
                            defaultExpanded
                            className={styles.accordion}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography
                                variant="subtitle1"
                                className="accrodionHeading"
                              >
                                Sibling {index + 1}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box
                                className={`${styles.fieldRow} ${styles.fieldRowOth}`}
                              >
                                <TextField
                                  fullWidth
                                  id={`familyDetails.siblings[${index}].name`}
                                  name={`familyDetails.siblings[${index}].name`}
                                  label={`Name *`}
                                  value={sibling.name || ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    (formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.name ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.familyDetails?.siblings?.[
                                          index
                                        ] as any
                                      )?.name
                                    )
                                  }
                                  helperText={
                                    (formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.name ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    (
                                      formik.errors.familyDetails?.siblings?.[
                                        index
                                      ] as any
                                    )?.name
                                  }
                                  className={styles.textFourField}
                                  disabled={appStatus}
                                />
                                <TextField
                                  fullWidth
                                  select
                                  id={`familyDetails.siblings[${index}].relationship`}
                                  name={`familyDetails.siblings[${index}].relationship`}
                                  label={`Relationship *`}
                                  value={sibling.relationship || ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    (formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.relationship ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.familyDetails?.siblings?.[
                                          index
                                        ] as any
                                      )?.relationship
                                    )
                                  }
                                  helperText={
                                    (formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.relationship ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    (
                                      formik.errors.familyDetails?.siblings?.[
                                        index
                                      ] as any
                                    )?.relationship
                                  }
                                  className={styles.textSmallField}
                                  disabled={appStatus}
                                >
                                  <MenuItem value="">
                                    Select Relationship
                                  </MenuItem>
                                  <MenuItem value="Brother">Brother</MenuItem>
                                  <MenuItem value="Sister">Sister</MenuItem>
                                </TextField>
                                <TextField
                                  fullWidth
                                  select
                                  id={`familyDetails.siblings[${index}].qualification`}
                                  name={`familyDetails.siblings[${index}].qualification`}
                                  label={`Education Qualification *`}
                                  value={sibling.qualification || ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    (formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.qualification ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.familyDetails?.siblings?.[
                                          index
                                        ] as any
                                      )?.qualification
                                    )
                                  }
                                  helperText={
                                    (formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.qualification ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    (
                                      formik.errors.familyDetails?.siblings?.[
                                        index
                                      ] as any
                                    )?.qualification
                                  }
                                  className={styles.textFourField}
                                  disabled={appStatus}
                                >
                                  {qualificationOptions.map((label) => (
                                    <MenuItem key={label} value={label}>
                                      {label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                                {isSister && (
                                  <>
                                    <TextField
                                      fullWidth
                                      id={`familyDetails.siblings[${index}].sisterHusbandName`}
                                      name={`familyDetails.siblings[${index}].sisterHusbandName`}
                                      label={`Husband's Name (if applicable)`}
                                      value={sibling.sisterHusbandName || ""}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      error={
                                        (formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandName ||
                                          formik.submitCount > 0) &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        Boolean(
                                          (
                                            formik.errors.familyDetails
                                              ?.siblings?.[index] as any
                                          )?.sisterHusbandName
                                        )
                                      }
                                      helperText={
                                        (formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandName ||
                                          formik.submitCount > 0) &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        (
                                          formik.errors.familyDetails
                                            ?.siblings?.[index] as any
                                        )?.sisterHusbandName
                                      }
                                      className={styles.textFourField}
                                      disabled={appStatus}
                                    />
                                    <TextField
                                      fullWidth
                                      select
                                      id={`familyDetails.siblings[${index}].sisterHusbandOccupation`}
                                      name={`familyDetails.siblings[${index}].sisterHusbandOccupation`}
                                      label={`Husband's Occupation`}
                                      value={
                                        sibling.sisterHusbandOccupation || ""
                                      }
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      error={
                                        (formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandOccupation ||
                                          formik.submitCount > 0) &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        Boolean(
                                          (
                                            formik.errors.familyDetails
                                              ?.siblings?.[index] as any
                                          )?.sisterHusbandOccupation
                                        )
                                      }
                                      helperText={
                                        (formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandOccupation ||
                                          formik.submitCount > 0) &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        (
                                          formik.errors.familyDetails
                                            ?.siblings?.[index] as any
                                        )?.sisterHusbandOccupation
                                      }
                                      className={styles.textFourField}
                                      disabled={appStatus}
                                    >
                                      {occupationOptions.map((label) => (
                                        <MenuItem key={label} value={label}>
                                          {label}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </>
                                )}

                                {formik.values.familyDetails?.siblings.length >
                                  1 &&
                                  !appStatus && (
                                    <Button
                                      startIcon={<RemoveCircleOutlineIcon />}
                                      color="error"
                                      onClick={() => remove(index)}
                                      className={styles.removeButton}
                                    >
                                      Remove
                                    </Button>
                                  )}
                              </Box>
                            </AccordionDetails>
                            {/* <Divider sx={{ my: 2 }} /> */}
                          </Accordion>
                        );
                      }
                    )}
                    {!appStatus && (
                      <Box
                        padding={2}
                        display={"flex"}
                        justifyContent={"flex-end"}
                      >
                        <Button
                          variant="contained"
                          startIcon={<AddCircleOutlineIcon />}
                          onClick={() =>
                            push({
                              id: 0,
                              name: "",
                              qualification: "",
                              relationship: "",
                            })
                          }
                          className={styles.commonBtn}
                        >
                          Add Another Sibling
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 5: // Scholarship Purpose
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Reason for seeking scholarship</span>
            </Typography>
            <Box className={styles.fieldRow} display={"block"}>
              <TextField
                select
                id="scholarshipPurpose.knowApplication"
                name="scholarshipPurpose.knowApplication"
                label="How did you come to know about SRBF Scholarship? *"
                value={formik.values.scholarshipPurpose.knowApplication || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  (formik.touched.scholarshipPurpose?.knowApplication ||
                    formik.submitCount > 0) &&
                  Boolean(formik.errors.scholarshipPurpose?.knowApplication)
                }
                helperText={
                  (formik.touched.scholarshipPurpose?.knowApplication ||
                    formik.submitCount > 0) &&
                  formik.errors.scholarshipPurpose?.knowApplication
                }
                className={styles.textAutoField}
                disabled={appStatus}
              >
                <MenuItem value="">Select Option</MenuItem>
                {KnowApplicationData.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <TextField
              fullWidth
              id="scholarshipPurpose.purposeExplanation"
              name="scholarshipPurpose.purposeExplanation"
              label="Please describe your purpose for applying for this scholarship. *"
              multiline
              rows={6}
              value={formik.values.scholarshipPurpose.purposeExplanation || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                (formik.touched.scholarshipPurpose?.purposeExplanation ||
                  formik.submitCount > 0) &&
                Boolean(formik.errors.scholarshipPurpose?.purposeExplanation)
              }
              helperText={
                (formik.touched.scholarshipPurpose?.purposeExplanation ||
                  formik.submitCount > 0) &&
                formik.errors.scholarshipPurpose?.purposeExplanation
              }
              className={styles.textField}
              disabled={appStatus}
            />
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ mb: 1, display: "block" }}
            >
              (Maximum 300 words)
            </Typography>
            <FormikProvider value={formik}>
              <FieldArray name="scholarshipPurpose.otherScholarships">
                {({ push, remove }) => (
                  <Box paddingTop={3}>
                    <Typography
                      variant="h6"
                      className={styles.sectionTitle}
                      marginBottom={3}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <span>Other Scholarships</span>
                    </Typography>
                    <Typography variant="body2" align="center" marginBottom={2}>
                      Please provide details of any other scholarships you are
                      already availing if applicable.
                    </Typography>
                    {formik.values.scholarshipPurpose.otherScholarships.map(
                      (scholarship, index) => {
                        return (
                          <Accordion
                            key={index}
                            defaultExpanded
                            className={styles.accordion}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography
                                variant="subtitle1"
                                className="accrodionHeading"
                              >
                                Scholarship {index + 1}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box className={`${styles.fieldRow}  `}>
                                <TextField
                                  id={`scholarshipPurpose.otherScholarships[${index}].scholarshipsName`}
                                  name={`scholarshipPurpose.otherScholarships[${index}].scholarshipsName`}
                                  label={`Scholarships Name`}
                                  value={scholarship.scholarshipsName || ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    (formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsName ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    Boolean(
                                      (
                                        formik.errors.scholarshipPurpose
                                          ?.otherScholarships?.[index] as any
                                      )?.scholarshipsName
                                    )
                                  }
                                  helperText={
                                    (formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsName ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    (
                                      formik.errors.scholarshipPurpose
                                        ?.otherScholarships?.[index] as any
                                    )?.scholarshipsName
                                  }
                                  className={styles.textFourField}
                                  disabled={appStatus}
                                />
                                <TextField
                                  fullWidth
                                  id={`scholarshipPurpose.otherScholarships[${index}].scholarshipsAmount`}
                                  name={`scholarshipPurpose.otherScholarships[${index}].scholarshipsAmount`}
                                  label={`Scholarships Amount`}
                                  type="number"
                                  value={scholarship.scholarshipsAmount || ""}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    (formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsAmount ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    Boolean(
                                      (
                                        formik.errors.scholarshipPurpose
                                          ?.otherScholarships?.[index] as any
                                      )?.scholarshipsAmount
                                    )
                                  }
                                  helperText={
                                    (formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsAmount ||
                                      formik.submitCount > 0) &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    (
                                      formik.errors.scholarshipPurpose
                                        ?.otherScholarships?.[index] as any
                                    )?.scholarshipsAmount
                                  }
                                  className={styles.textFourField}
                                  disabled={appStatus}
                                />

                                {formik.values.scholarshipPurpose
                                  ?.otherScholarships.length > 1 &&
                                  !appStatus && (
                                    <Button
                                      startIcon={<RemoveCircleOutlineIcon />}
                                      color="error"
                                      onClick={() => remove(index)}
                                      className={styles.removeButton}
                                    >
                                      Remove
                                    </Button>
                                  )}
                              </Box>
                            </AccordionDetails>
                            {/* <Divider sx={{ my: 2 }} /> */}
                          </Accordion>
                        );
                      }
                    )}
                    {!appStatus && (
                      <Box
                        padding={2}
                        display={"flex"}
                        justifyContent={"flex-end"}
                      >
                        <Button
                          variant="contained"
                          startIcon={<AddCircleOutlineIcon />}
                          onClick={() =>
                            push({
                              id: 0,
                              name: "",
                              scholarshipsName: "",
                              scholarshipsAmount: "",
                            })
                          }
                          className={styles.commonBtn}
                        >
                          Add Another Scholarship
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 6: // Bank Details
        return (
          <>
            <Box className={styles.formSection}>
              <Typography
                variant="h6"
                className={styles.sectionTitle}
                marginBottom={3}
                display={"flex"}
                justifyContent={"center"}
              >
                <span>Bank Details</span>
              </Typography>

              <FormikProvider value={formik}>
                <FieldArray name="bankDetails">
                  {({ push, remove }) => (
                    <Box>
                      {formik.values.bankDetails.map((bankItem, index) => (
                        <Accordion
                          key={index}
                          defaultExpanded
                          className={styles.accordion}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              variant="subtitle1"
                              className="accrodionHeading"
                            >
                              {bankItem.title}'s Account
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box className={styles.fieldRow}>
                              <Box display="flex" alignItems="center">
                                <Typography variant="body2" mr={1}>
                                  Primary Bank Account
                                </Typography>
                                <Checkbox
                                  checked={!!bankItem.isPrimary}
                                  onChange={() => {
                                    // Uncheck all others, check only this one
                                    const updatedBankDetails =
                                      formik.values.bankDetails.map(
                                        (item, idx) => ({
                                          ...item,
                                          isPrimary: idx === index,
                                        })
                                      );
                                    formik.setFieldValue(
                                      "bankDetails",
                                      updatedBankDetails
                                    );
                                  }}
                                  name={`bankDetails[${index}].isPrimary`}
                                  color="primary"
                                  disabled={appStatus}
                                />
                              </Box>
                            </Box>
                            {/* <Box className={styles.fieldRow}>
                              <TextField
                                id={`bankDetails[${index}].title`}
                                name={`bankDetails[${index}].title`}
                                label="Account Type"
                                value={bankItem.title || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]?.title &&
                                  typeof formik.errors.bankDetails?.[index] !== "string" &&
                                  Boolean((formik.errors.bankDetails?.[index] as any)?.title)
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]?.title &&
                                  typeof formik.errors.bankDetails?.[index] !== "string" &&
                                  (formik.errors.bankDetails?.[index] as any)?.title
                                }
                                className={styles.textAutoField}
                                disabled={appStatus}
                              />
                              
                            </Box> */}
                            <Box className={styles.fieldRow}>
                              <TextField
                                id={`bankDetails[${index}].bankName`}
                                name={`bankDetails[${index}].bankName`}
                                label="Bank Name *"
                                value={bankItem.bankName || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  (formik.touched.bankDetails?.[index]
                                    ?.bankName ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.bankName
                                  )
                                }
                                helperText={
                                  (formik.touched.bankDetails?.[index]
                                    ?.bankName ||
                                    formik.submitCount > 0) &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.bankName
                                }
                                className={styles.textAutoField}
                                disabled={appStatus}
                              />
                              <TextField
                                id={`bankDetails[${index}].accountHolderName`}
                                name={`bankDetails[${index}].accountHolderName`}
                                label="Account Holder Name *"
                                value={bankItem.accountHolderName || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountHolderName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.accountHolderName
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountHolderName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.accountHolderName
                                }
                                className={styles.textAutoField}
                                disabled={appStatus}
                              />
                              <TextField
                                id={`bankDetails[${index}].accountNumber`}
                                name={`bankDetails[${index}].accountNumber`}
                                label="Account Number *"
                                value={bankItem.accountNumber || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountNumber &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.accountNumber
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountNumber &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.accountNumber
                                }
                                className={styles.textAutoField}
                                disabled={appStatus}
                              />
                              <TextField
                                id={`bankDetails[${index}].ifscCode`}
                                name={`bankDetails[${index}].ifscCode`}
                                label="IFSC Code *"
                                value={bankItem.ifscCode || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.ifscCode &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.ifscCode
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.ifscCode &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.ifscCode
                                }
                                className={styles.textAutoField}
                                disabled={appStatus}
                              />
                              <TextField
                                id={`bankDetails[${index}].branchName`}
                                name={`bankDetails[${index}].branchName`}
                                label="Branch Name *"
                                value={bankItem.branchName || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.branchName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.branchName
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.branchName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.branchName
                                }
                                className={styles.textAutoField}
                                disabled={appStatus}
                              />
                            </Box>
                            {formik.values.bankDetails.length > 1 &&
                              !appStatus && (
                                <Button
                                  startIcon={<RemoveCircleOutlineIcon />}
                                  color="error"
                                  onClick={() => {
                                    remove(index)
                                    handleDeleteRow(formik.values.bankDetails[index], 'bank_detail');
                                  }}
                                  className={styles.removeButton}
                                >
                                  Remove
                                </Button>
                              )}
                          </AccordionDetails>
                        </Accordion>
                      ))}
                      {!appStatus && (
                        <Box
                          padding={2}
                          display={"flex"}
                          justifyContent={"flex-end"}
                        >
                          <Button
                            startIcon={<AddCircleOutlineIcon />}
                            variant="contained"
                            onClick={() =>
                              push({
                                title: "New Bank",
                                bankName: "",
                                accountHolderName: "",
                                accountNumber: "",
                                ifscCode: "",
                                branchName: "",
                                isPrimary: false,
                              })
                            }
                            className={styles.commonBtn}
                          >
                            Add More Bank
                          </Button>
                        </Box>
                      )}
                      {formik.touched.completedEducation &&
                        typeof formik.errors.completedEducation ===
                          "string" && (
                          <Typography
                            color="error"
                            variant="caption"
                            sx={{ mt: 1 }}
                          >
                            {formik.errors.completedEducation}
                          </Typography>
                        )}
                    </Box>
                  )}
                </FieldArray>
              </FormikProvider>
            </Box>
          </>
        );

      case 7: // Uploaded Documents
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Documents</span>
            </Typography>
            <Box className={styles.fieldRow}>
              <TextField
                id={`uploadedDocuments.docName`}
                name={`uploadedDocuments.docName`}
                label="Document Name"
                value={formik.values.uploadedDocuments.docName || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.uploadedDocuments?.docName &&
                  Boolean(formik.errors.uploadedDocuments?.docName)
                }
                helperText={
                  formik.touched.uploadedDocuments?.docName &&
                  formik.errors.uploadedDocuments?.docName
                }
                className={styles.textNoneField}
                sx={{
                  width: "20rem",
                }}
                disabled={appStatus}
              />

              <Box className={styles.fileUploadField}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0 }}
                  paddingBottom={"0.25rem"}
                >
                  Upload Document
                </Typography>
                <Box display={"flex"} alignItems={"center"}>
                  <Button
                    variant="contained"
                    component="label"
                    className={styles.commonBtn}
                    sx={{ flex: "none", marginRight: "1rem" }}
                    disabled={appStatus}
                  >
                    Choose File
                    <input
                      type="file"
                      hidden
                      onChange={(e) => handleDocumentUploadChange(e)}
                      disabled={appStatus}
                      ref={fileInputRef}
                    />
                  </Button>
                  <Typography variant="body2">
                    {formik.values.uploadedDocuments.file
                      ? formik.values.uploadedDocuments.fileName
                      : "No file chosen"}
                  </Typography>
                  {uploading && (
                    <Box className={styles.smallLoader} ml={2}>
                      <CircularProgress size={24} />
                    </Box>
                  )}
                  {formik.touched.uploadedDocuments?.file &&
                    formik.errors.uploadedDocuments?.file && (
                      <Typography color="error" variant="caption">
                        {formik.errors.uploadedDocuments?.file}
                      </Typography>
                    )}
                </Box>
              </Box>
            </Box>
            <Card
              style={{
                padding: "1rem 0.5rem",
                border: 0,
                boxShadow: "none",
                background: "none",
              }}
            >
              <Box className={"cardBoxUI cardBoxInnerUI"}>
                <CustomDataTable<FilesInterface>
                  data={mainData[0]?.additional_documents}
                  columns={columns}
                  tableTitle="Application Review"
                  rowsPerPage={10}
                  globalFilterEnabled={false}
                />
              </Box>
            </Card>
          </Box>
        );

      default:
        return (
          <Typography variant="h6" sx={{ mt: 2 }}>
            Unknown Step
          </Typography>
        );
    }
  };
  const isEmptyValue = (value: any): boolean => {
    if (value === null || value === undefined) return true;
    if (typeof value === "string" && value.trim() === "") return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === "object" && !Array.isArray(value)) {
      return Object.keys(value).length === 0;
    }
    return false;
  };

  const isEqualDeep = (obj1: any, obj2: any): boolean => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  };
  const extractDeltaObject = (current: any, previous: any): any => {
    const delta: any = {};

    for (const key in current) {
      const currentValue = current[key];
      const previousValue = previous?.[key];

      if (isEmptyValue(currentValue)) continue;

      const isChanged = !isEqualDeep(currentValue, previousValue);

      if (isChanged) {
        delta[key] = currentValue;
      }
    }

    return delta;
  };

  const extractFileName = (url: string): string | null => {
    try {
      const pathname = new URL(url).pathname;
      return pathname.split("/").pop() || null;
    } catch (err) {
      // Fallback: try splitting as a regular string (non-URL)
      const parts = url.split("/");
      return parts.length ? parts[parts.length - 1] : null;
    }
  };
  const secureAllDocuments = async (documents: any[]) => {
    const securedDocs = await Promise.all(
      documents.map(async (doc) => {
        try {
          const secureUrl = await getSecureBlobUrl({
            fileName: extractFileName(doc.doc_url) as any,
            blobBaseUrl: BLOB_API,
            getTokenUrl: `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}`,
          });

          return {
            ...doc,
            doc_url: secureUrl,
            originalDocUrl: doc.doc_url,
          };
        } catch (error) {
          console.error(`Error securing URL for ${doc.doc_name}`, error);
          return doc; // fallback to original if failed
        }
      })
    );

    return securedDocs;
  };

  const updateAppDetailsMutation = useMutationByMethod<any>(
    "patch",
    `${PatchUrl.updateApplicationDetails}?is_admin=true`
  );
  const hasAllKeys = (obj: any, requiredKeys: string[]) => {
    return requiredKeys.every((key) => {
      const val = obj[key];
      return val !== undefined && val !== null && val !== "";
    });
  };

  const applicationAllFieldsData = () => {
    const appid = localStorage.getItem("applicationID");
    const objValues = formik.values;
    const titleList = [
      "Secondary Education",
      "Higher Secondary Education",
      "Graduation",
      "Post Graduation",
    ];
    const completedEdu = objValues.completedEducation
      .filter((item) =>
        hasAllKeys(item, [
          "nameSchoolCollege",
          "schoolCollegeAddress",
          "nameOfUniversity",
          "course",
          "stream",
          "marksObtainedCGPA",
          "yearOfPassing",
          "principalName",
          "principalContactNumber",
          "uploadMarksheet",
        ])
      )
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          title: item.id ? item.course : titleList[index],
          institution: item.nameSchoolCollege,
          address: item.schoolCollegeAddress,
          university_name: item.nameOfUniversity,
          stream: item.stream,
          course: item.course,
          total_marks_cgpa: item.marksObtainedCGPA,
          year_of_passing: item.yearOfPassing,
          principal_name: item.principalName,
          principal_ph: item.principalContactNumber,
          marksheet_url: item.fileName,
          file_name: item.docName,
        };
      });
    const datamapSibling = objValues.familyDetails.siblings
      .filter((item) =>
        hasAllKeys(item, ["name", "relationship", "qualification"])
      )
      .map((item) => {
        const base = {
          id: item.id ? item.id : 0,
          sibling_name: item.name,
          relationship: item.relationship,
          occupation: item.qualification,
          sister_husband_name: item.sisterHusbandName,
          sister_husband_occupation: item.sisterHusbandOccupation,
        };

        // Conditionally enrich with sister's husband details
        if (item.relationship === "sister") {
          return {
            ...base,
            sister_husband_name: item.sisterHusbandName,
            sister_husband_occupation: item.sisterHusbandOccupation,
          };
        }

        return base;
      });
    const datamapother = objValues.scholarshipPurpose.otherScholarships
      .filter((item) =>
        hasAllKeys(item, ["scholarshipsName", "scholarshipsAmount"])
      )
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          scholarship_name: item.scholarshipsName,
          scholarship_amount: item.scholarshipsAmount,
        };
      });
    const datamapachievements = objValues.achievementsInfo
      .filter((item) => hasAllKeys(item, ["fileName"]))
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          achievement: item.docName,
          supporting_doc_url: item.fileName,
          file_name: item.docFileName,
        };
      });
    const bankTitleList = ["Student", "Parent", "Guardian", "College/School"];
    const bankInfo = objValues.bankDetails
      .filter((item) =>
        hasAllKeys(item, [
          "bankName",
          "accountHolderName",
          "accountNumber",
          "ifscCode",
          "branchName",
        ])
      )
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          title: bankTitleList[index],
          bank_name: item.bankName,
          account_holder_name: item.accountHolderName,
          account_no: item.accountNumber,
          IFSC_no: item.ifscCode,
          branch: item.branchName,
          primary_indicator: item.isPrimary ? item.isPrimary : false,
        };
      });
    const presentEducation = [objValues.presentEducation]
      .filter((item) =>
        hasAllKeys(item, [
          "nameSchoolorCollege",
          "schoolCollegeAddress",
          "nameOfUniversity",
          "course",
          "stream",
          "yearOfAdmission",
          "currentSemester",
          "courseDuration",
          "principalName",
          "principalContactNumber",
          "courseFees",
          "paymentFrequency",
          "totalFeesPaid",
        ])
      )
      .map((item) => {
        return {
          id: item.id ? item.id : 0,
          institution: item.nameSchoolorCollege,
          address: item.schoolCollegeAddress,
          university_name: item.nameOfUniversity,
          stream: item.stream,
          course: item.course,
          Year_of_Admission: item.yearOfAdmission,
          Current_sem: item.currentSemester,
          Course_dur: item.courseDuration,
          principal_name: item.principalName,
          principal_ph: item.principalContactNumber,
          Course_fee: item.courseFees,
          Frequency_of_payment: item.paymentFrequency,
          Fees_Already_paid: item.totalFeesPaid,
        };
      });
    const personalInfo = [objValues.personalInfo]
      .filter((item) =>
        hasAllKeys(item, [
          "firstName",
          "lastName",
          "email",
          "mobileNumber",
          "dateOfBirth",
          "permanentHomeAddress",
          "city",
          "zipcode",
          "state",
          "district",
          "profilePhoto",
          "gender",
        ])
      )
      .map((item) => {
        return {
          first_name: item.firstName,
          last_name: item.lastName,
          email: item.email,
          phone: item.mobileNumber,
          dob: item.dateOfBirth,
          home_address: item.permanentHomeAddress,
          city: item.city,
          zipcode: item.zipcode,
          state: item.state,
          district: item.district,
          photo_url: item.profilePhotoName,
          facebook_url: item.socialMediaHandleFB || null,
          instagram_url: item.socialMediaHandleInstagram || null,
          linkedin_url: item.socialMediaHandleLinkedIn || null,
          gender: item.gender,
        };
      });
    const familyDetails = [objValues.familyDetails]
      .filter((item) =>
        hasAllKeys(item, [
          "fathersName",
          "mothersName",
          "guardiansName",
          "fathersOccupation",
          "mothersOccupation",
          "familyIncome",
          "contactNumber",
        ])
      )
      .map((item) => {
        return {
          father_name: item.fathersName,
          mother_name: item.mothersName,
          guardian_name: item.guardiansName,
          father_occupation: item.fathersOccupation,
          mother_occupation: item.mothersOccupation,
          monthly_familiy_income: item.familyIncome,
          guardian_ph_number: item.contactNumber,
          siblings: datamapSibling,
        };
      });
    const scholarshipPurpose = [objValues.scholarshipPurpose]
      .filter((item) =>
        hasAllKeys(item, ["knowApplication", "purposeExplanation"])
      )
      .map((item) => {
        return {
          source_of_infomation: item.knowApplication,
          scholarship_purpose: item.purposeExplanation,
          other_scholarships: datamapother,
        };
      });

    const uploadedDocs = Array.isArray(objValues.uploadedDocuments)
      ? objValues.uploadedDocuments
      : objValues.uploadedDocuments
      ? [objValues.uploadedDocuments]
      : [];
    const objsWithId0 = uploadedDocs.filter((item) => item.id === 0);
    const additionalDocuments = objsWithId0
      .filter((item) => hasAllKeys(item, ["documentsPreview", "fileName"]))
      .map((item) => {
        return {
          id: item.id ?? 0,
          doc_name: item.fileName,
          doc_url: item.documentsPreview,
        };
      });

    const obj = {
      application_id: applicationID || appid,
      personal_info: personalInfo[0],
      completedEducation: completedEdu,
      presentEducation: presentEducation,
      achievements: datamapachievements,
      family_details: familyDetails[0],
      scholarship_purpose: scholarshipPurpose[0],
      bank_details: bankInfo,
      additional_documents: additionalDocuments,
    };
    return obj;
  };
  const deltaPayload = extractDeltaObject(
    applicationAllFieldsData(),
    mainData[0]
  );

  const patchAppCreateReq = async () => {
    setLoading(true);
    showLoader();
    console.log("deltaPayload==", deltaPayload);
    updateAppDetailsMutation.mutate(deltaPayload, {
      onSuccess: (data) => {
        setLoading(false);
        hideLoader();
        ToastService.success("Your Application Update successfully!");
        fetchApplicationData();
        setTimeout(() => {
          navigate(-1);
        }, 3000);
      },
      onError: (err) => {
        setLoading(false);
        console.error("error", err);
        hideLoader();
      },
    });
  };

  const extractTopLevelKeys = (errors: any): string[] => {
    const keys: string[] = [];

    const recurse = (obj: any, parentKey: string | null = null) => {
      if (typeof obj === "string" && parentKey) {
        keys.push(parentKey);
      } else if (Array.isArray(obj)) {
        obj.forEach((item) => recurse(item, parentKey));
      } else if (typeof obj === "object" && obj !== null) {
        Object.entries(obj).forEach(([key, value]) => {
          recurse(value, parentKey || key);
        });
      }
    };

    recurse(errors);
    return Array.from(new Set(keys)); // ✅ ensures unique root keys
  };
  const getFirstInvalidStepIndex = (errors: any): number | null => {
    const invalidKeys = extractTopLevelKeys(errors);
    for (const key of invalidKeys) {
      if (sectionStepMap[key] !== undefined) {
        return sectionStepMap[key];
      }
    }
    return null;
  };
  useEffect(() => {
    const checkInitialValidation = async () => {
      const errors = await formik.validateForm(); // triggers validation
      const firstInvalidStep = getFirstInvalidStepIndex(errors);
      if (firstInvalidStep !== null) {
        setActiveStep(firstInvalidStep);
      }
    };

    checkInitialValidation();
  }, []);

  const statusSubmited = (values: any) => {
    console.log("values==", values);
    setStatusArr([values]);
    setModalOpen(false);
    statusSubmitedCall(values);
  };

  const updateAppDetailsStatus = useMutationByMethod<any>(
    "patch",
    `${PatchUrl.updateStatus}`
  );

  const statusSubmitedCall = (values: any) => {
    const obj = {
      application_id: applicationID,
      application_status: values.status,
      interviwer_commnets: values.remarks,
    };

    console.log("obj==", obj);
    updateAppDetailsStatus.mutate(obj, {
      onSuccess: (data) => {
        setLoading(false);
        console.log("data new===", data);
        hideLoader();
        // formik.handleSubmit();
        handleFinalSubmit();
      },
      onError: (err) => {
        setLoading(false);
        console.error("error", err);
        hideLoader();
      },
    });
  };
  const extractValidSteps = (errors: any): Set<number> => {
    const invalidKeys = extractTopLevelKeys(errors); // from previous utility
    const allSteps = Object.keys(sectionStepMap);
    return new Set(
      allSteps
        .filter((stepKey) => !invalidKeys.includes(stepKey))
        .map((validKey) => sectionStepMap[validKey])
    );
  };

  const validatedSteps = extractValidSteps(formik.errors);
  const handleSuccessModalClose = () => {
    setViewDocModalOpen(false);
  };
  useEffect(() => {
    if (selectedRow) {
      setViewDocModalOpen(true);
    }
  }, [selectedRow]);
  const filePreviewHandler = (row: any, tabname: string) => {
    let obj: any = {};
    if (tabname === "achievementsInfo") {
      obj = {
        id: row.id,
        doc_name: row.docFileName,
        doc_url: row.uploadPreview ? row.uploadPreview : row.uploadMarksheet,
      };
    } else if (tabname === "completedEducation") {
      obj = {
        id: row.id,
        doc_name: row.docName,
        doc_url: row.uploadMarksheetPreview
          ? row.uploadMarksheetPreview
          : row.uploadMarksheet,
      };
    }
    selectedRow && setSelectedRow(null);
    setSelectedRow(obj);
  };

  if (!mainData) return <div>Loading form...</div>;
  return (
    <Container className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h5" className={styles.title}>
          Scholarship Application Form
        </Typography>
        <Box className={styles.navigationButtons}>
          <Button
            variant="text"
            startIcon={<ChevronLeftIcon />}
            className={styles.navButton}
            onClick={handleBack}
            disabled={activeStep === 0}
          >
            Previous
          </Button>
          <Button
            variant="text"
            endIcon={<ChevronRightIcon />}
            className={styles.navButton}
            onClick={handleNext}
            disabled={activeStep === steps.length - 1}
          >
            Next
          </Button>
          <Button
            variant="contained"
            className={styles.saveButton}
            onClick={() => setModalOpen(true)}
            disabled={
              applicationManageArr[0]?.status === "approved" ? true : false
            }
          >
            Update Application
          </Button>
          <StatusUpdateModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            onSubmit={(values) => {
              console.log("Form Values", values);
              statusSubmited(values);
            }}
            statusOptions={statusOptions.filter(
              (item: any) => item.value !== "approved" && item.value !== "draft"
            )}
            initialStatus={applicationManageArr[0].status}
          />
        </Box>
      </Box>

      <Stepper
        activeStep={activeStep}
        className={styles.stepper}
        alternativeLabel={!isMobile}
        orientation={isMobile ? "vertical" : "horizontal"}
        connector={<CustomConnector />}
      >
        {steps.map((label, index) => {
          const isStepValidated = validatedSteps.has(index);
          const isClickable = isStepValidated || index === activeStep;
          return (
            <Step
              key={label}
              onClick={() => {
                if (isClickable) {
                  setActiveStep(index);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <StepLabel
                StepIconComponent={CustomStepIcon}
                className={
                  `${styles.steperLabelText} ` +
                  (index === activeStep ? styles.activeStepLabel : "")
                }
              >
                <span className={styles.textSpan}>{label}</span>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingBottom={2}
      >
        <Box p={0} display={"flex"} alignItems={"center"}>
          <Typography>Application ID: </Typography>
          <Typography fontWeight={"bold"}>{applicationID}</Typography>
        </Box>
        <Box p={0} display={"flex"} alignItems={"center"} gap={2}>
          <Typography display={"flex"} alignItems={"center"}>
            Status:
          </Typography>
          <Chip
            label={
              statusOptions.find(
                (m: any) => m.value === applicationManageArr[0]?.status
              )?.label
            }
            color={getStatusChipColor(applicationManageArr[0]?.status)}
            size="small"
            variant="filled"
            style={{ fontWeight: 600, textTransform: "capitalize" }}
          />
        </Box>
      </Box>
      <Divider sx={{ marginBottom: 3 }} />
      <Box
        ref={formRef}
        style={{ scrollMarginTop: "180px" }}
        className={"formPanel"}
      >
        <form onSubmit={formik.handleSubmit} className="form-group">
          {getStepContent(activeStep)}
        </form>
      </Box>
      <AuditLog data={auditLogs} />
      <Dialog
        open={viewDocModalOpen}
        onClose={handleSuccessModalClose}
        PaperProps={{
          sx: {
            width: 700,
            maxWidth: "90%",
          },
        }}
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="h6" color="success.main">
              {selectedRow && selectedRow?.doc_name}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedRow?.doc_url?.includes(".pdf") ? (
            <PdfPreview url={selectedRow?.doc_url} />
          ) : (
            <img
              src={selectedRow?.doc_url}
              alt="Document Preview"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "4px",
                objectFit: "cover",
                boxShadow: "0 0 6px rgba(0,0,0,0.1)",
              }}
            />
          )}
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "1rem",
          }}
        >
          <Button
            onClick={handleSuccessModalClose}
            variant="contained"
            className={styles.commonButton}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ScholarshipApplicationView;
